export const APP_CHANGELOG = [
  {
    version: "v2.6.0",
    date: "2026-05-04",
    title: "🚀 Rekrutacja Online + Feedback Zmiany + Globalne Odświeżanie + UX Cleanup",
    features: [
      {
        category: "🧑‍💼 Nowy moduł — Rekrutacja Internetowa (publiczny formularz CV + admin CRM)",
        items: [
          "✅ **Publiczna strona** `/rekrutacja` — formularz dla kandydatów (BEZ logowania)",
          "  • 5 sekcji: Dane podstawowe / Stanowisko / Dyspozycyjność / Doświadczenie / Pytania dodatkowe / Zgody RODO",
          "  • Profesjonalny design zgodny z LoginScreen (granat #0d1b2a + złoto #d4af37, glass-morphism, logo MR JERRY)",
          "  • Wsparcie parametrów `?source=facebook|instagram|olx|polecenie|strona|inne` — śledzenie źródła kandydata",
          "  • Wsparcie `?location=krakow|nowysacz|grodek` — pre-select lokalizacji",
          "  • Anti-spam: honeypot field + rate-limit per phoneNormalized (5/h)",
          "",
          "✅ **Panel admina** — zakładka `🧑‍💼 Rekrutacja internetowa` (URL `/rekrutacja-internetowa`)",
          "  • Lista zgłoszeń z licznikami statusów (Wszystkie / Nowe / Do kontaktu / Zadzwoniono / Umówiony / Nie odebrał / Odrzucony / Przyjęty / Rezerwa)",
          "  • Filtry: status, stanowisko, rodzaj pracy, doświadczenie, weekendy, daty",
          "  • Wyszukiwarka pełnotekstowa (imię, telefon, miasto)",
          "  • Generator linka udostępniania z auto-doborem `?source=...`",
          "  • Modal szczegółów kandydata: zmiana statusu, notatki kierownika, historia notatek z autorem i timestampem, ustawienie daty rozmowy, propozycja stanowiska/wynagrodzenia, oznaczenie jako przyjęty",
          "  • Przycisk `📞 Zadzwoń` (tel:) + `📋 Kopiuj numer`",
          "",
          "✅ Stary moduł trial-days przemianowany: **🧑‍💼 Rekrutacja → 📅 Dni próbne** (URL `/rekrutacja-dni-probne`) — żeby nazewniczo i wizualnie nie kolidował z nowym modułem"
        ]
      },
      {
        category: "🤫 Nowa zakładka — Feedback Zmiany (Informacje Dnia)",
        items: [
          "✅ Anonimowy formularz dla kelnerów po zmianie — **0 user_id w bazie** (100% prywatne)",
          "✅ 5 pól: Plusy dnia / Minusy dnia / Opinie gości o jedzeniu / Opinie gości o napojach / Inne uwagi",
          "✅ Zakładka **`📚 Historia feedbacków`** dla managera i pracownika — filtry (lokalizacja, daty, wyszukiwarka pełnotekstowa)",
          "✅ Manager może usuwać poszczególne wpisy",
          "✅ 4 zakładki w widoku managera (Dzisiejsza odprawa / Historia odpraw / Feedback zmiany / Historia feedbacków)",
          "✅ 3 zakładki w widoku pracownika (Informacje dnia / Feedback zmiany / Historia feedbacków)"
        ]
      },
      {
        category: "🔄 Globalna ikona odświeżania — działa wszędzie",
        items: [
          "✅ Klik 🔄 w nagłówku odświeża **WSZYSTKIE** zakładki (przedtem tylko 9 z ~30)",
          "✅ Działa również dla: Sprzedaż, Szkła, Czyszczenie piwa, Straty kuchenne, Briefing, Promocje, Zakupy, Grafika, Opinie, Rekrutacja internetowa, Dni próbne, Inwentaryzacja, Zamknięcie miesiąca, Kasa, Analiza managerska, Komunikator, Przypomnienia, Materiały, Delikatesy, Feedback zmiany",
          "✅ Implementacja oparta o `refreshKey` w `AppStateContext` + re-mount kontenera tabu — **zero modyfikacji** w istniejącym kodzie zakładek"
        ]
      },
      {
        category: "🐛 Poprawki UX",
        items: [
          "✅ **Modal opinii / kandydata** — pełne okno BEZ scrollbara (React Portal naprawia bug stacking-context od `.tab-transition-wrap` z `will-change: transform`)",
          "✅ **Sidebar — wyszukiwarka modułów przyklejona do góry** (już nie scrolluje się razem z listą zakładek; flex-column z osobnym `.sidebar-scroll-area`)",
          "✅ **Fix routingu Delikatesy** — kliknięcie nie skacze już najpierw na Napiwki (dodano brakujące `delikatesy` i `forms` do `TAB_TO_PATH`)",
          "✅ **Fix linku `Otwórz rekrutację`** w Przypomnieniach — kierował błędnie do publicznego formularza CV; teraz prowadzi do panelu Dni próbne (`/rekrutacja-dni-probne`)",
          "✅ Modal szczegółów kandydata przeprojektowany na styl modala Opinii (jednokolumnowy, kompaktowy, sticky bottom z przyciskami Zapisz/Usuń/Anuluj)",
          "✅ Brakujące ścieżki URL dodane: `/opinie`, `/inwentaryzacja`, `/zamkniecie-miesiaca`, `/delikatesy`, `/formularze`"
        ]
      }
    ]
  },
  {
    version: "v2.5.4",
    date: "2026-04-30",
    title: "🔄 Straty kuchenne — Konwersja plików inwentaryzacyjnych",
    features: [
      {
        category: "🔄 Nowy konwerter CSV/XLSX/XLS/TXT",
        items: [
          "✅ Przycisk **„🔄 Konwersja pliku\"** w hub Strat kuchennych (menu manager) + w nagłówku KitchenLossesTab",
          "✅ Obsługa formatów: **CSV, XLSX, XLS, TXT**",
          "✅ Automatyczne wykrywanie separatora (`;`, `,`, `\\t`, `|`) i kodowania (UTF-8, CP1250, Latin-2)",
          "",
          "⚙️ Logika przetwarzania (zgodnie ze specyfikacją):",
          "  • Wyciąga **kod** z kolumny produktu (regex: `kod[\\s:]*(\\d+)`, case-insensitive)",
          "  • Pobiera ilość z kolumny **„Stan po\"**",
          "  • Zamienia przecinek na kropkę (1,5 → 1.5)",
          "  • Liczby całkowite bez części dziesiętnej (10 zamiast 10.0)",
          "  • Pomija rekordy bez kodu / bez ilości / z ilością ≤ 0",
          "  • Numeruje wyniki od 1 (Lp)",
          "",
          "📋 Wyjście CSV w formacie `Lp;kod;ilość` (bez nagłówka, separator `;`, bez apostrofów/formuł)",
          "🎯 3 akcje na wyniku: **📋 Kopiuj do schowka** / **💾 Pobierz CSV** / przegląd w textarea (monospace)",
          "🚨 Czytelne błędy: brak kolumn, pusty plik, nie rozpoznany format"
        ]
      }
    ]
  },
  {
    version: "v2.5.3",
    date: "2026-04-29",
    title: "🌙 Kasa — Zliczanie na koniec dnia + przypomnienie wieczorne",
    features: [
      {
        category: "🌙 Zliczanie stanu kasy na koniec zmiany",
        items: [
          "✅ Nowa sekcja **„Zliczanie kasy na koniec dnia\"** w module Kasa",
          "✅ Manager wpisuje rzeczywistą kwotę w kasie + opcjonalnie kto liczył + notatkę",
          "",
          "🧮 **Live preview różnicy** podczas wpisywania:",
          "  • ✅ Zgadza się (zielony) — różnica < 0,01 zł",
          "  • ⚠️ Nadwyżka (żółty) — w kasie więcej niż oczekiwane",
          "  • ⚠️ Niedobór (czerwony) — w kasie mniej niż oczekiwane",
          "",
          "📜 Historia ostatnich 5 zliczeń (z opcją „Pokaż wszystkie\") z różnicami i notatkami",
          "🔄 Upsert: ponowne zapisanie tego samego dnia nadpisuje poprzednie zliczenie",
          "💾 Backend: kolekcja `cash_daily_counts` z polami expected/counted/difference"
        ]
      },
      {
        category: "🔔 Przypomnienie wieczorne",
        items: [
          "✅ Nowa reguła **`cash_daily_count`** w silniku Przypomnień",
          "✅ Po godz. `eveningDeadlineHour` (domyślnie 23:00) — alert średniej wagi 💰",
          "✅ Treść: „Brak zliczenia stanu kasy na koniec dnia\" + przycisk „Otwórz Kasę\"",
          "✅ Reguła konfigurowalna: można wyłączyć lub zmienić godzinę w Ustawieniach Przypomnień",
          "✅ Push notification do managera, jeśli włączone"
        ]
      }
    ]
  },
  {
    version: "v2.5.2",
    date: "2026-04-29",
    title: "🗓️ Rekrutacja — widok kalendarza miesięcznego + naprawa wpisywania w Analizie managerskiej",
    features: [
      {
        category: "🗓️ Widok kalendarza w Rekrutacji",
        items: [
          "✅ Nowy filtr **„🗓️ Widok kalendarza\"** w zakładce Rekrutacja",
          "✅ Pełna siatka miesiąca (Pn–Nd) z numerami dni i podświetleniem dzisiaj (złoty border)",
          "✅ Każdy dzień z dniem próbnym pokazuje:",
          "  • Liczbę kandydatów (złoty badge w prawym górnym rogu)",
          "  • Miniatury (max 3) z imieniem i pierwszą literą nazwiska + ikoną statusu (⏳/✅/👍/💰/🎯)",
          "  • Złote tło dla dni z kandydatami",
          "✅ Nawigacja: ← Poprzedni / Dziś / Następny →",
          "✅ Licznik **„X dni próbnych w tym miesiącu\"** w nagłówku",
          "✅ Klik w dzień → przełączenie do filtra „Kalendarz (1 dzień)\" + automatyczne ustawienie daty",
          "✅ Legenda kolorów statusów na dole",
          "✅ Filtr „📅 Kalendarz\" przemianowany na **„📅 Kalendarz (1 dzień)\"** dla rozróżnienia"
        ]
      },
      {
        category: "🐛 Naprawa wpisywania w Analizie managerskiej",
        items: [
          "✅ **Bug**: po wpisaniu jednej cyfry input tracił focus → trzeba było klikać po każdym znaku",
          "✅ **Root cause**: `Field` był zdefiniowany inline w `EntryForm` → React odmontowywał input przy każdym keystroke",
          "✅ **Fix**: wyciągnięty `FieldInput` na zewnątrz komponentu jako stabilny typ + zamiana `<Field>` na `<FieldInput>` w 6 polach"
        ]
      }
    ]
  },
  {
    version: "v2.5.1",
    date: "2026-04-29",
    title: "💰 Nowy moduł — Kasa",
    features: [
      {
        category: "💰 Zarządzanie stanem kasy lokalu",
        items: [
          "✅ **Hero card** z aktualnym stanem kasy + 4 KPI: stan bazowy, nieoddane, oddane, current",
          "✅ Wzór: **Aktualny stan = Stan bazowy − suma nieoddanych wydatków**",
          "✅ Manager ustawia **stan bazowy** kasy (z notatką + datą ostatniej zmiany)",
          "",
          "📝 Dodawanie wydatków:",
          "  • Data + kwota + kategoria (🛒 zakupy, 💼 pracownicze, 🚚 dostawcy, 🛠️ naprawa, 🚗 transport, 📦 inne)",
          "  • Komu wydano + opis + uwagi",
          "  • Każdy wydatek startuje jako 🔴 nieoddany",
          "",
          "🔄 Toggle „✅ Oddane\":",
          "  • Klik → kwota **wraca do stanu kasy** (current rośnie)",
          "  • Można cofnąć: „↩️ Cofnij oddanie\"",
          "  • Wpisy zwrócone wyświetlone z line-through + ✅ Oddane <data>",
          "",
          "🔍 Filtry: 🔴 Nieoddane / ✅ Oddane / 📋 Wszystkie",
          "📅 Lista zgrupowana miesiącami (MonthlyCollapsibleList)",
          "",
          "🔐 Uprawnienia:",
          "  • `cash_view` — kelnerzy widzą stan + wydatki",
          "  • `cash_manage` — manager dodaje/edytuje/oznacza oddane/zmienia stan bazowy"
        ]
      }
    ]
  },
  {
    version: "v2.5.0",
    date: "2026-04-27",
    title: "🎬 Filmiki demonstracyjne w Samouczku — wszystkie 24 moduły",
    features: [
      {
        category: "🎬 Auto-screencasty Playwright dla każdej kategorii",
        items: [
          "✅ **24 nagrane filmiki** (.webm, ~10 sekund każdy) demonstrujące każdy moduł",
          "✅ Hostowane w `/public/tutorials/{id}.webm` (~40 MB total)",
          "✅ W każdej kategorii samouczka pojawia się **video player** pod nagłówkiem",
          "✅ **Autoplay + muted + loop** — film startuje sam przy otwarciu kategorii",
          "✅ Kontrolki natywne (play/pause/seek/full-screen) + badge „🎬 Demo: {tytuł}\"",
          "✅ Skrypt nagrywający w `/app/scripts/record_tutorials.py` — można powtórzyć po większych zmianach UI"
        ]
      }
    ]
  },
  {
    version: "v2.4.9",
    date: "2026-04-27",
    title: "📚 Nowy moduł Samouczek + ukrycie Nowości z menu",
    features: [
      {
        category: "📚 Samouczek MR JERRY (nowy moduł)",
        items: [
          "✅ Zastąpił „Nowości\" w menu — kompleksowy poradnik dla managera",
          "✅ **22 sekcje** opisujące każdy moduł aplikacji A-Z (Komunikator, Napiwki, Briefing, Sprzedaż, Manager, Analiza managerska, Zaangażowanie, Rekrutacja, Delikatesy, Ustawienia, FAQ i więcej)",
          "✅ **Wyszukiwarka** w lewej kolumnie — szukasz po tytule, tagach i treści",
          "✅ **Markdown-light**: pogrubienia, kod, listy kroków, tip-y (zielone), ostrzeżenia (żółte)",
          "✅ Persistencja **w localStorage**: ostatnio otwarta sekcja + checkbox „przeczytane\" per kategoria",
          "✅ Pasek progresu „X z 22\" + nawigacja Poprzednia/Następna na dole każdej sekcji",
          "✅ Routing `/samouczek`, dostępny dla wszystkich zalogowanych"
        ]
      },
      {
        category: "🆕 Nowości — schowane z menu",
        items: [
          "✅ Przycisk usunięty z sidebar i hamburger menu",
          "✅ Changelog **nadal dostępny** przez przycisk wersji w nagłówku (klik `v2.4.9` → modal)",
          "✅ Routing `/nowosci` zachowany (deeplinki działają)"
        ]
      }
    ]
  },
  {
    version: "v2.4.8",
    date: "2026-04-26",
    title: "✨ Animacje przejść + Skeleton Loaders + Centrum Powiadomień",
    features: [
      {
        category: "🎬 Animowane przejścia między zakładkami",
        items: [
          "✅ Każde przełączenie zakładki — efekt **fade-in + slide-up** (240 ms, cubic-bezier easing)",
          "✅ Aplikacja od razu wygląda znacznie bardziej premium",
          "✅ Respekt `prefers-reduced-motion` — użytkownicy z preferencją wyłączonych animacji nadal widzą natychmiastowe przełączenia"
        ]
      },
      {
        category: "💀 Skeleton Loaders zamiast „⏳ Ładowanie…\"",
        items: [
          "✅ Nowy komponent `Skeleton` z pulsującą animacją gradientu (shimmer)",
          "✅ Warianty: `Skeleton`, `SkeletonText`, `SkeletonCard`, `SkeletonList`, `SkeletonKPIGrid`",
          "✅ Wdrożone w modułach: Zaangażowanie zespołu (lista + raport), Delikatesy (ranking + historia)",
          "✅ Manager Analytics już korzysta z istniejących skeleton cards"
        ]
      },
      {
        category: "🔔 Centrum Powiadomień (dzwoneczek w nagłówku)",
        items: [
          "✅ Nowy komponent `NotificationCenter` w nagłówku — między ThemeToggle a info użytkownika",
          "✅ Konsoliduje **nieprzeczytane wiadomości komunikatora** + **aktywne przypomnienia** w jednym miejscu",
          "✅ Pulsujący czerwony badge na dzwonku z łączną liczbą",
          "✅ Dropdown z animacją pop (180 ms): kliknij pozycję → przejście do zakładki + zamknięcie",
          "✅ Empty state „✨ Brak powiadomień — wszystko pod kontrolą\" gdy zero spraw",
          "✅ Zamykanie ESC / klik poza dropdownem"
        ]
      }
    ]
  },
  {
    version: "v2.4.7",
    date: "2026-04-26",
    title: "🤝 Nowy moduł — Zaangażowanie zespołu",
    features: [
      {
        category: "🤝 Rejestrowanie dodatkowych prac pracowników",
        items: [
          "✅ Nowa zakładka **Zaangażowanie zespołu** w menu (wszystkie lokalizacje)",
          "",
          "📝 Formularz dodawania wpisu:",
          "  • Data, pracownik (autocomplete z historii), kategoria, opis, czas (minuty), zlecający (autocomplete)",
          "  • 5 kategorii: 📣 Marketing, 🔧 Techniczne, 🗂️ Organizacyjne, 🧹 Porządkowe, 📦 Inne",
          "",
          "🔄 Statusy i przepływ:",
          "  • Nowy wpis = ⏳ **Oczekuje** (domyślnie)",
          "  • Manager zmienia: ✅ Zaakceptowane / ✏️ Do poprawy / ❌ Odrzucone (z opcjonalnym komentarzem)",
          "  • Wpis **zaakceptowany** zostaje zablokowany — nikt nie może już go edytować",
          "  • Wpis **do poprawy** może edytować pracownik — po zapisaniu wraca do statusu „oczekuje\"",
          "",
          "📋 Lista wpisów (zgrupowana po miesiącu via MonthlyCollapsibleList):",
          "  • Filtry: status, kategoria, pracownik (po nazwie)",
          "  • Karta z kolorowym lewym borderem (żółty/zielony/niebieski/czerwony)",
          "  • Akcje managera: ✅ Zaakceptuj / ✏️ Do poprawy / ❌ Odrzuć (z polem komentarza)",
          "",
          "📊 Raport miesięczny (TYLKO dla managera):",
          "  • Wybór roku + miesiąca",
          "  • 4 KPI: wpisów łącznie, zaakceptowane minuty, oczekujące, do poprawy",
          "  • 🏆 Ranking pracowników (medale 🥇🥈🥉, sortowanie po sumie zaakceptowanych minut)",
          "  • 📂 Breakdown czasów wg kategorii (zaakceptowane zadania)",
          "",
          "🔐 Uprawnienia:",
          "  • `team_engagement` — pracownik dodaje i widzi wpisy lokalizacji",
          "  • `team_engagement_manage` — manager zarządza statusami + raport miesięczny"
        ]
      }
    ]
  },
  {
    version: "v2.3.1",
    date: "2026-04-25",
    title: "📥 Import XML do Analizy managerskiej",
    features: [
      {
        category: "📥 Import danych historycznych z XML",
        items: [
          "✅ Nowa sekcja w **Ustawieniach** → '📈 Import danych historycznych — Analiza managerska'",
          "  • Wybierz rok + miesiąc + plik .xml → wczytaj jednym kliknięciem",
          "  • Każdy import dotyczy jednego miesiąca — możesz wgrywać po jednym XML na każdy miesiąc 2025",
          "",
          "🔄 Inteligentny parser XML:",
          "  • Akceptuje pola jako atrybuty (`<entry date='2025-04-15' salesNet='4000' />`)",
          "  • Akceptuje pola jako tagi (`<entry><date>2025-04-15</date><salesNet>4000</salesNet></entry>`)",
          "  • Polskie nazwy: `sprzedaz`, `gosci`, `rachunki`, `koszt_pracownikow`, `godziny`, `typ_dnia`",
          "  • Angielskie nazwy: `salesNet`, `guestsCount`, `billsCount` itd.",
          "  • Daty w wielu formatach: 2025-04-15, 15.04.2025, 15/04/2025",
          "  • Polskie wartości typu dnia: `zwykły`, `weekend`, `święto`, `event`, `specjalny`",
          "",
          "🛡️ Bezpieczeństwo:",
          "  • Wpisy z innego miesiąca niż wybrany są pomijane (z raportem dat)",
          "  • Idempotentny — ponowny import tego samego dnia aktualizuje istniejący rekord",
          "  • Pełny raport po imporcie: dodane, zaktualizowane, pominięte, błędy",
          "",
          "📄 Przycisk **'Pobierz przykład XML'** — pobiera gotowy szablon do wzorowania się"
        ]
      }
    ]
  },
  {
    version: "v2.3.0",
    date: "2026-04-25",
    title: "📈 Nowy moduł: Analiza managerska restauracji",
    features: [
      {
        category: "📊 Co wpisujesz",
        items: [
          "Manager wpisuje dziennie podstawowe liczby:",
          "  • Data i lokalizacja",
          "  • Sprzedaż netto + liczba gości + liczba rachunków",
          "  • Koszt pracowników + roboczogodziny",
          "  • Typ dnia (zwykły / weekend / święto / event / dzień specjalny)",
          "  • Uwagi (impreza firmowa, słaba pogoda, awaria...)"
        ]
      },
      {
        category: "🔢 Co aplikacja liczy automatycznie",
        items: [
          "✅ Średni rachunek globalny — sprzedaż / liczba rachunków",
          "✅ Sprzedaż na gościa — sprzedaż / goście",
          "✅ Koszt pracownika jako % sprzedaży",
          "✅ Sprzedaż na roboczogodzinę",
          "✅ Liczba gości na roboczogodzinę",
          "✅ Dynamika YoY: sprzedaż, goście, średni rachunek (porównanie z analogicznym dniem tygodnia + typem dnia rok wcześniej)"
        ]
      },
      {
        category: "🎨 Widok",
        items: [
          "🗓️ **Dashboard miesięczny** z 6 kartami kluczowych metryk + kolorowe oznaczenia YoY (zielony = lepiej, czerwony = gorzej, żółty = neutralnie)",
          "📋 **Tabela dzienna**: data + dzień tygodnia + typ + wszystkie wskaźniki dla każdego dnia",
          "💡 **Auto-komentarz** generowany przez backend, np. 'Sprzedaż wzrosła o 12% YoY, ale liczba gości wzrosła o 20% — sprawdź jakość sprzedaży'",
          "✏️ Edycja i 🗑️ usuwanie wpisów inline (manager only)",
          "📅 Wybór miesiąca i roku w nagłówku — porównanie z dowolnym okresem"
        ]
      },
      {
        category: "🔒 Uprawnienia",
        items: [
          "Nowe uprawnienie **manager_analytics** w Panelu Managera",
          "Bez uprawnienia: zakładka niewidoczna",
          "Z uprawnieniem: pełen dostęp do edycji + dodawania",
          "Manager (super-user) ma dostęp automatycznie"
        ]
      }
    ]
  },
  {
    version: "v2.2.13",
    date: "2026-04-25",
    title: "✨ Animowane szkielety zamiast 'Ładowanie...'",
    features: [
      {
        category: "🎨 Loading skeletons w wielu miejscach",
        items: [
          "✅ Zastąpiono goły tekst 'Ładowanie...' animowanymi szkieletami w kształcie docelowej zawartości",
          "  • Aplikacja wydaje się ~2× szybsza bez zmian na backendzie",
          "  • Subtelna animacja shimmer w kolorach motywu",
          "",
          "🔧 Pokryte ekrany:",
          "  • Globalny TabLoadingFallback (wszystkie zakładki ładowane przez Suspense)",
          "  • Sprzedaż: Dashboard, Produkty, Reguły, Ranking, Moje statystyki, Kalkulator",
          "  • Sprzedaż / Panel managera: Reguły, Zadania, Pytania, Skrypty, Produkty, Ustawienia, Kelnerzy, Scenariusze",
          "  • Przypomnienia, Wybór kelnera, Projekty graficzne",
          "",
          "📦 Reusable: nowy komponent <SkeletonListFallback /> używany w 11 plikach"
        ]
      }
    ]
  },
  {
    version: "v2.2.12",
    date: "2026-04-24",
    title: "🚪 Usprawnienia UX w module Sprzedaż",
    features: [
      {
        category: "👥 Liczba kelnerów na zmianie — dostępna od razu",
        items: [
          "✅ Widget 'Kelnerzy na zmianie dziś' jest teraz widoczny od razu po wejściu w Sprzedaż",
          "  • Nie musisz już wybierać profilu kelnera, żeby ustawić liczbę osób",
          "  • Manager może ustawić zmianę jednym kliknięciem przy pierwszym wejściu dnia",
          "  • Liczba wpływa na przypomnienie 'Trening dnia kelnerów' w module Przypomnienia"
        ]
      },
      {
        category: "🚪 Przycisk 'Wyjdź' z profilu kelnera",
        items: [
          "✅ Nowy czerwony przycisk 'Wyjdź' obok 'Zmień kelnera' w nagłówku Sprzedaży",
          "  • Szybkie wylogowanie z profilu kelnera bez potwierdzenia",
          "  • Powrót do ekranu wyboru kelnera",
          "  • Komunikat 'Wylogowano z profilu kelnera' po kliknięciu",
          "",
          "💡 Przydatne gdy kilku kelnerów korzysta z tego samego urządzenia w ciągu zmiany"
        ]
      }
    ]
  },
  {
    version: "v2.2.11",
    date: "2026-04-24",
    title: "📚 Przypomnienie treningu dnia + Liczba kelnerów na zmianie",
    features: [
      {
        category: "📚 Trening dnia kelnerów jako nowa reguła",
        items: [
          "✅ Nowa reguła w module Przypomnienia: 'Trening dnia kelnerów'",
          "  • Sprawdza czy wszyscy kelnerzy na zmianie ukończyli trening do godz. 13:00 (edytowalne)",
          "  • Porównuje liczbę ukończonych `sales_training_completed` z liczbą kelnerów na zmianie",
          "  • Alert PILNY pokazuje np. 'Pozostało 3 z 6 kelnerów'",
          "  • Automatycznie znika po ukończeniu treningu przez odpowiednią liczbę kelnerów"
        ]
      },
      {
        category: "👥 Liczba kelnerów na zmianie (widget w Sprzedaży)",
        items: [
          "✅ Nowy widget '👥 Kelnerzy na zmianie dziś' u góry Dashboard Sprzedaży",
          "  • Manager ustawia liczbę kelnerów na dziś (0-50)",
          "  • Widoczny dla wszystkich, edytowalny przez managera/sales_manager",
          "  • Bez ustawionej liczby → trening dnia nie jest śledzony (łagodny alert INFO)",
          "",
          "🔌 Backend:",
          "  • GET /api/sales/shift-count?location&date",
          "  • PUT /api/sales/shift-count?location (body: {waitersCount, date?})",
          "  • Osobny rekord per dzień w kolekcji `sales_shift_count`"
        ]
      }
    ]
  },
  {
    version: "v2.2.10",
    date: "2026-04-24",
    title: "⚙️ Osobne godziny per reguła + uprawnienia Przypomnień",
    features: [
      {
        category: "🔔 Przypomnienia — osobne godziny per reguła",
        items: [
          "✅ Każda z 5 reguł (odprawa, napiwki, sprzedaż, zamknięcie dnia, rekrutacja) ma teraz własne pole godziny",
          "  • Puste pole = używana godzina domyślna (poranna / wieczorna)",
          "  • Wypełnione pole (0-23) = własna godzina tylko dla tej reguły",
          "  • Pole jest aktywne tylko gdy reguła jest włączona",
          "",
          "📐 Backend: pole `ruleHours` w `reminder_settings` z walidacją 0..23 per reguła (null = fallback)"
        ]
      },
      {
        category: "👔 Nowe uprawnienia w Panelu Managera",
        items: [
          "✅ Dwa nowe uprawnienia do ustawienia per pracownik:",
          "  • 🔔 **Przypomnienia** — dostęp do zakładki i podgląd alertów",
          "  • ⚙️ **Przypomnienia (edycja)** — zmiana godzin i reguł",
          "",
          "🔒 Manager Panel → przy każdym pracowniku dostępne checkboxy 'reminders' i 'reminders_edit'",
          "🛡️ Gdy brak 'reminders_edit' → panel ustawień przypomnień jest readonly z komunikatem"
        ]
      }
    ]
  },
  {
    version: "v2.2.9",
    date: "2026-04-24",
    title: "🔔 Moduł Przypomnień + Kalkulator średniego rachunku",
    features: [
      {
        category: "🔔 Nowa kategoria: Przypomnienia",
        items: [
          "✅ Osobna zakładka w menu z czerwonym badge'em pokazującym liczbę zaległych zadań",
          "",
          "📋 Reguły wykrywania automatycznie sprawdzane co 60 sekund:",
          "  • Brak karty odprawy do godz. 13:00 (PILNE)",
          "  • Brak wpisanych napiwków po godz. 23:00 (PILNE)",
          "  • Brak wyników sprzedaży po godz. 23:00 (UWAGA)",
          "  • Dzień niezamknięty po godz. 23:00 (UWAGA)",
          "  • Nieodznaczona rekrutacja — kandydat miał dzień próbny dziś/w przeszłości, ale nie został zaakceptowany ani odrzucony",
          "",
          "⚙️ Konfigurowalność:",
          "  • Godziny deadline'ów można zmieniać per lokalizacja",
          "  • Każdą regułę można włączyć/wyłączyć osobno",
          "  • Push notification do managerów (rate-limited — max 1/godz/lokalizacja/dzień)",
          "",
          "🎯 Bezpośrednie akcje: każdy alert ma przycisk prowadzący wprost do odpowiedniej zakładki",
        ]
      },
      {
        category: "🧮 Kalkulator średniego rachunku w Sprzedaży",
        items: [
          "✅ Nowa zakładka 'Kalkulator' w module Sprzedaż",
          "  • Wpisujesz przychód + liczbę osób → natychmiastowy wynik średnio/osoba",
          "  • Polski format PLN (136,14 zł), przecinek akceptowany jako separator",
          "  • Prawidłowa odmiana polska (1 osoba, 2 osoby, 5 osób)",
          "  • Przycisk 'Wyczyść' do szybkiego resetu",
          "  • Dostępny dla wszystkich — kelnerów i managera"
        ]
      }
    ]
  },
  {
    version: "v2.2.8",
    date: "2026-04-23",
    title: "🔴 Badge nieodczytanych w Komunikatorze + automatyczne czyszczenie starych zdjęć",
    features: [
      {
        category: "💬 Komunikator — Badge nieodczytanych wiadomości",
        items: [
          "✅ Czerwony badge z liczbą nieprzeczytanych wiadomości przy zakładce 'Komunikator'",
          "  • Widoczny w sidebarze (desktop) i w hamburger menu (mobile)",
          "  • Liczba pulsuje delikatnie, pokazuje '99+' gdy > 99",
          "  • Odświeżanie co 10 sekund w tle",
          "",
          "🔁 Automatyczne oznaczanie jako przeczytane:",
          "  • Wejście w zakładkę Komunikator natychmiast zeruje licznik",
          "  • Każde odświeżenie wiadomości (co 3s) również aktualizuje stan 'ostatnio widziane'",
          "  • Nie liczą się własne wiadomości — tylko te od innych osób",
          "",
          "🆕 Nowe endpointy API:",
          "  • GET /api/communicator/unread-count — zwraca liczbę nieprzeczytanych + ile z nich to wzmianki dla mojego piętra",
          "  • POST /api/communicator/mark-seen — oznacza wiadomości jako przeczytane dla usera"
        ]
      },
      {
        category: "🧹 Automatyczne czyszczenie starych zdjęć w odprawach",
        items: [
          "✅ Automatyczny cron uruchamiany w każdą niedzielę o 3:00 rano",
          "  • Skanuje kolekcję 'daily_briefings' pod kątem starych linków typu /static/briefing_images/...",
          "  • Konwertuje do Base64 (jeśli plik istnieje na dysku) lub usuwa zepsuty link",
          "  • Chroni przed problemami po restarcie kontenera / utracie plików statycznych",
          "",
          "🛠️ Ręczna naprawa na żądanie:",
          "  • Nowa sekcja 'Naprawa starych zdjęć w odprawach' w Ustawieniach (manager only)",
          "  • Przyciski 'Sprawdź (dry-run)' i 'Uruchom naprawę' z czytelnym raportem",
          "",
          "🖼️ Graceful fallback na frontendzie:",
          "  • Zepsute obrazki ukrywają się automatycznie (zamiast ikony 'broken image')",
          "  • Dotyczy widoku manager form + briefing detail"
        ]
      },
      {
        category: "🏠 Zakładka 'Start' tymczasowo wyłączona",
        items: [
          "✅ Zakładka 'Start' (Dashboard) została czasowo ukryta z menu",
          "  • Strona główna aplikacji ( / ) teraz prowadzi bezpośrednio do Komunikatora",
          "  • Stare linki do /komunikator automatycznie przekierowują do /",
          "  • Kod Dashboard nie został usunięty — wróci w kolejnych wersjach po przeprojektowaniu widgetów"
        ]
      }
    ]
  },
  {
    version: "v2.2.7",
    date: "2026-04-23",
    title: "💬 Komunikator - czat zespołowy z piętrami i szybkimi komunikatami",
    features: [
      {
        category: "💬 Komunikator (NOWA ZAKŁADKA!)",
        items: [
          "✅ Nowa zakładka 'Komunikator' na sidebarze (dla wszystkich zalogowanych)",
          "  • URL: /komunikator",
          "  • Widoczna tuż pod Start",
          "",
          "📍 Wybór piętra przy wejściu:",
          "  • Modal 'Gdzie pracujesz?' przy pierwszym wejściu",
          "  • 4 domyślne piętra dla Krakowa: Sala główna 🍽️, Piwniczka 🍷, Loft 🏛️, Delikatesy 🥩",
          "  • Wybór zapamiętany w localStorage per urządzenie + użytkownik",
          "  • Szybka zmiana piętra jednym kliknięciem badge'a w nagłówku",
          "",
          "💬 Wspólny czat lokalizacji:",
          "  • Wszyscy pracownicy lokalizacji widzą te same wiadomości",
          "  • Każda wiadomość oznaczona piętrem nadawcy (ikona + nazwa)",
          "  • Własne wiadomości po prawej (złota ramka)",
          "  • Cudze po lewej (niebieska ramka)",
          "  • Pilne wiadomości w czerwonej ramce z badge 🚨 PILNE",
          "",
          "⚡ Szybkie komunikaty (predefiniowane przyciski):",
          "  • 🆘 Potrzebujemy pomocy na sali (PILNE)",
          "  • 👔 Proszę o podejście managera (PILNE)",
          "  • 📦 Kończy się [produkt]",
          "  • 📋 Gość pyta o kartę",
          "  • 🍞 Poproszę wodę / chleb",
          "  • 🙏 Dziękuję!",
          "",
          "🔔 Powiadomienia:",
          "  • Push notification (VAPID) na telefonie dla PILNYCH wiadomości",
          "  • Dźwięk beep w przeglądarce przy nowej wiadomości (urgent = podwójny beep)",
          "  • Auto-scroll do najnowszej",
          "  • Polling co 3 sekundy",
          "",
          "⚙️ Panel ustawień (tylko manager):",
          "  • Dodawanie i usuwanie pięter / sekcji (własna ikona + nazwa)",
          "  • Dodawanie i usuwanie szybkich komunikatów (+ flaga 'pilne')",
          "  • Konfiguracja per lokalizacja (Kraków może mieć 4 piętra, inna lokalizacja mniej)",
          "  • Manager może też usuwać dowolną wiadomość z czatu",
          "",
          "🔐 Uprawnienia:",
          "  • Każdy zalogowany widzi i pisze",
          "  • Tylko manager zarządza piętrami i szybkimi komunikatami",
          "  • Tylko manager może usuwać cudze wiadomości",
          "",
          "📢 @Wzmianki per piętro (NOWOŚĆ w ramach 2.2.7):",
          "  • Pod inputem 'Skieruj do:' z chip-ami dla każdego piętra",
          "  • Klik = dodaj piętro jako adresata wiadomości",
          "  • Bubble pokazuje '📢 Do: @Piwniczka, @Loft' w nagłówku",
          "  • Push notification idzie TYLKO do userów obecnych na wspomnianych piętrach",
          "  • Złote podświetlenie gdy moje piętro jest wspomniane",
          "  • Ogranicza szum powiadomień przy dużym ruchu",
          "",
          "🟢 Presence - kto jest online:",
          "  • Zielony pasek na górze z listą pięter i liczbą userów",
          "  • Tooltip po najechaniu pokazuje loginy",
          "  • Liczniki przy @mention chips — szybko widać czy wybrane piętro ma kogoś online",
          "  • Obecność rejestrowana automatycznie przy wyborze piętra",
          "",
          "✏️ Typing indicator:",
          "  • Gdy ktoś pisze, pozostali widzą 'Jan (Piwniczka) pisze...' z animowanymi kropkami",
          "  • Auto-TTL 5s, debounce 2s na stronie klienta",
          "",
          "⌨️ Wbudowana klawiatura ekranowa (Polski QWERTY):",
          "  • Toggle '⌨️ Wbud./System.' w nagłówku — przełącza między klawiaturą wbudowaną a systemową",
          "  • 5 rzędów z polskimi znakami (ł, ż, ź, ć, ą, ę, ó, ń, ś)",
          "  • Shift (auto-off po 1 znaku), Backspace, Spacja, Enter (wyślij), Close (schowaj)",
          "  • Przycisk 🚨 PILNE na klawiaturze — oznacza kolejną wiadomość jako pilną",
          "  • Systemowa klawiatura się nie wysuwa (input readOnly + inputMode=none)",
          "  • Pamiętane w localStorage (zostaje przy kolejnej wizycie)",
          "",
          "🔍 Tryb kompaktowy:",
          "  • Toggle '🔍 Kompakt / 📐 Normalny' w nagłówku",
          "  • Mniejsze bubble (padding ↓45%, font ↓15%, max-width 65%)",
          "  • Więcej wiadomości widocznych na ekranie",
          "  • Pamiętane w localStorage"
        ]
      }
    ]
  },
  {
    version: "v2.2.6",
    date: "2026-04-22",
    title: "🏠 Profesjonalny Dashboard - ekran startowy aplikacji",
    features: [
      {
        category: "🏠 Dashboard (NOWY EKRAN STARTOWY!)",
        items: [
          "✅ Nowa zakładka '🏠 Start' na samej górze menu (domyślna po zalogowaniu)",
          "  • Dostępna dla wszystkich użytkowników",
          "  • URL: / (strona główna)",
          "",
          "👋 Powitanie:",
          "  • Kontekstowe: 'Dzień dobry/Smacznego obiadu/Dobrej zmiany wieczornej' itd.",
          "  • Aktualna data (dzień tygodnia + pełna data po polsku)",
          "  • Zegar live aktualizowany co 30 sekund",
          "  • 30 motywujących cytatów, jeden losowany na dzień",
          "",
          "⚡ Szybkie akcje (4 kafelki):",
          "  • 💵 Dodaj napiwek → przejście do zakładki Napiwki",
          "  • 🔪 Dodaj stratę → przejście do Strat kuchennych",
          "  • 📋 Odprawa → przejście do Informacji Dnia",
          "  • 💰 Sprzedaż → przejście do modułu Sprzedaż",
          "  • 🔒 Zamknij dzień (jeśli nie zamknięty)",
          "",
          "📈 Dziś vs Wczoraj:",
          "  • Przychód dzisiejszy + delta % vs wczoraj",
          "  • Liczba gości + delta %",
          "  • Kwota napiwków",
          "  • Liczba kelnerów na zmianie",
          "",
          "📋 Podgląd odprawy dnia:",
          "  • Najnowsza odprawa z celem sprzedażowym, kuchnią, barem",
          "  • Klik → pełna odprawa",
          "",
          "🍺 Czyszczenie piwa:",
          "  • Duży licznik: dni do kolejnego czyszczenia",
          "  • Kolor: zielony (>3 dni) / żółty (≤3 dni) / czerwony (po terminie)",
          "  • Daty ostatniego i kolejnego czyszczenia",
          "",
          "🎂 Nadchodzące urodziny:",
          "  • Pracownicy z urodzinami w ciągu 7 dni",
          "  • Specjalny badge 'DZISIAJ!' dla dzisiejszych jubilatów",
          "  • Wiek, który pracownik kończy",
          "",
          "🏆 Top 3 kelnerzy miesiąca:",
          "  • Ranking wg napiwków w bieżącym miesiącu",
          "  • Medale 🥇🥈🥉 z kolorowymi ramkami (złoto/srebro/brąz)",
          "  • Liczba zmian w miesiącu",
          "  • Motywuje zespół już od rana",
          "",
          "📝 Notatki zespołowe (per lokalizacja):",
          "  • Szybkie dodawanie przypomnień / notatek",
          "  • Współdzielone w obrębie lokalizacji",
          "  • Checkbox 'wykonane' + kasowanie",
          "  • Autor notatki widoczny dla zespołu",
          "",
          "🎨 Design:",
          "  • Hero header z gradientem złoto-niebieski",
          "  • 6 kart widgetów w responsywnym gridzie",
          "  • Hover effects na klikalnych kartach",
          "  • Spójny ciemny motyw z resztą aplikacji"
        ]
      }
    ]
  },
  {
    version: "v2.2.5",
    date: "2026-04-22",
    title: "🧑‍💼 Rekrutacja - kompletny moduł zarządzania dniami próbnymi kandydatów",
    features: [
      {
        category: "🧑‍💼 Rekrutacja (NOWA ZAKŁADKA!)",
        items: [
          "✅ Nowa dedykowana zakładka: Rekrutacja",
          "  • Dostępna dla wszystkich lokalizacji (Nowy Sącz, Kraków, Gródek)",
          "  • Widoczna w nawigacji desktop i mobile",
          "  • URL: /rekrutacja (deep-link)",
          "",
          "📋 Dodawanie kandydatów:",
          "  • Imię i Nazwisko",
          "  • Data dnia próbnego (date picker)",
          "  • Godzina rozpoczęcia (time picker)",
          "  • Stanowisko (dropdown z bazy job_positions)",
          "  • 🎓 Student/uczeń (checkbox – wpływa na księgowość)",
          "  • Stawka za dzień próbny (PLN)",
          "  • Notatki dodatkowe",
          "",
          "🎯 Statusy kandydata (toggle):",
          "  • ✅ Przyszedł na dzień próbny",
          "  • 👍 OK do pracy",
          "  • 💰 Wypłacony (+ modal z kwotą)",
          "",
          "⭐ Ocena kandydata (5 gwiazdek):",
          "  • Klikalne gwiazdki dla bieżącego dnia próbnego",
          "  • Każdy dzień próbny w historii też można ocenić osobno",
          "  • Klik tej samej gwiazdki = reset oceny",
          "",
          "📊 Statystyki na górze zakładki:",
          "  • Wszystkich kandydatów",
          "  • Ilu przyszło",
          "  • Ilu OK do pracy",
          "  • Ilu wypłaconych",
          "",
          "🗓️ Filtry widoku:",
          "  • ⚡ DZIŚ (domyślny)",
          "  • 🌅 Jutro",
          "  • 📅 Kalendarz (z date pickerem na dowolny dzień)",
          "  • 📜 Historia (przeszłe dni próbne)",
          "  • 📋 Wszystkie",
          "  • 🎯 Zaakceptowane rekrutacje (zatrudnieni)",
          "  • 🏁 Zakończone rekrutacje (rezygnacje)",
          "",
          "🔜 Kolejny dzień próbny:",
          "  • Przycisk pojawia się po oznaczeniu OK do pracy / Wypłacony",
          "  • Modal z wyborem nowej daty i godziny",
          "  • Automatyczna numeracja: 1. dzień, 2. dzień, 3. dzień...",
          "  • Poprzedni dzień zapisuje się w historii (z oceną, kwotą)",
          "  • Badge '🔜 N. dzień próbny ustalony' na karcie",
          "",
          "🎯 Zaakceptuj vs 🏁 Zakończ:",
          "  • 🎯 Zaakceptuj – kandydat zatrudniony, przenosi do 'Zaakceptowane rekrutacje' (zielona ramka)",
          "  • 🏁 Zakończ rekrutację – rezygnacja, przenosi do 'Zakończone rekrutacje' (szara ramka)",
          "  • Można zakończyć rekrutację po dowolnej liczbie dni próbnych",
          "  • Zaakceptowani/zakończeni znikają z głównego kalendarza",
          "",
          "📜 Rozsuwana Historia kandydata:",
          "  • Przycisk '📜 Historia (N)' przy każdej karcie",
          "  • Pokazuje wszystkie poprzednie dni próbne z ocenami i wypłatami",
          "  • Interaktywne gwiazdki dla każdego historycznego dnia",
          "  • Możliwość dopisywania uwag z timestampem (np. 'dobrze gada z gośćmi')",
          "  • Niebieskie wpisy = uwagi, szare = dni próbne",
          "",
          "💰 Rozliczenie wypłat:",
          "  • Modal z kwotą wypłaty za dni próbne",
          "  • 0 zł = 'Nie został wypłacony' (czerwony)",
          "  • > 0 zł = '💰 Wypłacono: X zł' (złoty)",
          "",
          "🎨 Dodatkowe UX:",
          "  • Złota pulsująca ramka wokół kandydatów 'DZIŚ'",
          "  • Ciemne modale spójne z motywem aplikacji (zamiast window.prompt)",
          "  • Walidacja pól przed zapisem",
          "  • Toasty potwierdzające każdą akcję"
        ]
      }
    ]
  },
  {
    version: "v2.2.4",
    date: "2026-04-22",
    title: "🔔 Push Notifications + PWA + Refaktoring App.js",
    features: [
      {
        category: "📱 PWA (Progressive Web App)",
        items: [
          "✅ Instalacja aplikacji na telefon/desktop",
          "  • Baner 'Zainstaluj aplikację' na Android/desktop Chrome",
          "  • iOS: użyj menu Share → 'Dodaj do ekranu głównego'",
          "  • Service Worker z cache'em offline",
          "  • Snooze baneru na 7 dni przy odrzuceniu"
        ]
      },
      {
        category: "🔔 Push Notifications (VAPID)",
        items: [
          "✅ Powiadomienia push bez Firebase (natywne Web Push)",
          "  • Opt-in baner po zalogowaniu",
          "  • Toggle w Ustawieniach (włącz/wyłącz)",
          "  • Manager może wysyłać manualne powiadomienia do całej lokalizacji",
          "",
          "🔔 Automatyczne triggery:",
          "  • Nowa odprawa dzienna → push do całej lokalizacji",
          "  • Nowy problem / pomysł zgłoszony → push do developerów"
        ]
      },
      {
        category: "🔗 Shareable Reports",
        items: [
          "✅ URL query params na /raporty (?from=X&to=Y)",
          "  • Zakres dat synchronizuje się z URL w obie strony",
          "  • Przycisk '🔗 Udostępnij link' (WhatsApp/SMS/clipboard)",
          "  • Deep-link automatycznie ustawia zakres dat"
        ]
      },
      {
        category: "🛠️ Refaktoring wewnętrzny",
        items: [
          "✅ App.js 2084 → 118 linii (wydzielenie MainApp + 5 custom hooks)",
          "✅ DailyBriefingTab: 1646 → 455 linii (6 podkomponentów)",
          "✅ Prawdziwy routing z react-router-dom + back button"
        ]
      }
    ]
  },
  {
    version: "v2.2.3",
    date: "2026-04-15",
    title: "👥 Zespół rozwoju - dedykowana zakładka do zarządzania pomysłami i problemami",
    features: [
      {
        category: "👥 Zespół rozwoju (NOWA ZAKŁADKA!)",
        items: [
          "✅ Nowa dedykowana zakładka: Zespół rozwoju",
          "  • Dostępna tylko dla lokalizacji Nowy Sącz",
          "  • Zabezpieczona kodem PIN",
          "  • Widoczna w nawigacji desktop i mobile",
          "",
          "💡 Pomysły użytkowników:",
          "  • Przeniesiono listę pomysłów z zakładki Ustawienia",
          "  • Rozsuwane listy (accordion) - kompaktowy widok",
          "  • Kliknij aby rozwinąć/zwinąć szczegóły (▶/▼)",
          "  • Zarządzanie statusami:",
          "    - ⏳ Oczekujące",
          "    - 👀 Przejrzane",
          "    - ✅ Wdrożone",
          "    - ❌ Odrzucone",
          "  • Filtrowanie po statusie",
          "  • Wyświetlanie: autor, lokalizacja, data zgłoszenia",
          "",
          "🐛 Problemy w restauracji (NOWE!):",
          "  • Anonimowe zgłaszanie problemów bez logowania",
          "  • Pływający przycisk 🐛 na ekranie logowania (prawy dolny róg)",
          "  • Modal zgłaszania:",
          "    - Wybór lokalizacji (Nowy Sącz, Kraków, Gródek)",
          "    - Opis problemu (konflikty, kłótnie, nieporozumienia)",
          "    - Całkowita anonimowość zgłoszenia",
          "  • Lista zgłoszonych problemów w zakładce Zespół rozwoju",
          "  • Rozsuwane listy (accordion)",
          "  • Zarządzanie statusami:",
          "    - ⏳ Oczekujące",
          "    - ✅ Rozwiązane",
          "    - ❌ Odrzucone",
          "  • Filtrowanie po statusie",
          "  • Wyświetlanie: opis, lokalizacja, data zgłoszenia"
        ]
      },
      {
        category: "🎨 Ulepszenia UI/UX",
        items: [
          "✅ Rozsuwane listy (Accordion):",
          "  • Domyślnie zwinięte - bardziej kompaktowy widok",
          "  • Strzałki ▶ (zwinięte) / ▼ (rozwinięte)",
          "  • Hover effect przy najechaniu",
          "  • Płynne animacje rozwijania/zwijania",
          "  • Widok zwinięty: tytuł + status + podstawowe info",
          "  • Widok rozwinięty: pełne szczegóły + kontrolki",
          "",
          "✅ Pływający przycisk zgłaszania problemów:",
          "  • Czerwony przycisk 🐛 w prawym dolnym rogu ekranu logowania",
          "  • Animacja pulse dla przyciągnięcia uwagi",
          "  • Tooltip z opisem 'Zgłoś problem'",
          "  • Gradient design z świecącym efektem"
        ]
      },
      {
        category: "🔧 Zmiany techniczne",
        items: [
          "✅ Nowy backend router: /api/development",
          "  • Przeniesiono endpointy pomysłów z /api/settings",
          "  • Publiczny endpoint dla zgłaszania problemów (bez JWT)",
          "  • Zabezpieczenie kodem PIN dla przeglądania",
          "",
          "✅ Kolekcje MongoDB:",
          "  • feature_suggestions - pomysły użytkowników",
          "  • reported_problems - zgłoszone problemy",
          "  • Dodano do systemu backupów",
          "",
          "✅ Routing i nawigacja:",
          "  • Nowa zakładka w desktop sidebar (Navbar)",
          "  • Nowa zakładka w mobile menu (HamburgerMenu)",
          "  • Lazy loading komponentu DevelopmentTab"
        ]
      }
    ],
    improvements: [
      "⚡ Bardziej kompaktowy interfejs dzięki rozsuwannym listom",
      "🔐 PIN-protected dostęp do zgłoszeń zespołu rozwoju",
      "📱 Pełna responsywność na mobile i desktop",
      "💬 Jasne rozróżnienie między pomysłami a problemami",
      "🎯 Fokus na problemy w restauracji (konflikty zespołu) zamiast technicznych"
    ]
  },
  {
    version: "v2.2.2",
    date: "2026-04-14",
    title: "📋 Protokoły magazynowe - nowy moduł dokumentacji",
    features: [
      {
        category: "📋 Protokoły magazynowe (NOWE!)",
        items: [
          "✅ Nowy moduł: Protokoły zniszczenia/straty towaru",
          "  • Dostępny w: Straty → Protokoły magazynowe (tylko Manager)",
          "  • Upload plików PDF (wzory lub istniejące protokoły)",
          "  • Automatyczne parsowanie PDF (tekst + skany OCR)",
          "  • Wyciąganie: nagłówków, tabel produktów, sum VAT",
          "",
          "📝 Inteligentne parsowanie PDF:",
          "  • pdfplumber - dla tekstowych PDF (szybkie)",
          "  • OpenAI Vision (Gemini 2.5 Flash) - dla skanów (OCR)",
          "  • Automatyczne rozpoznawanie tabel z produktami",
          "  • Wykrywanie kategorii VAT (5%, 8%, 23%)",
          "  • Polskie znaki w pełni obsługiwane",
          "",
          "✏️ Pełna edycja protokołów:",
          "  • Edycja nagłówka (nr dokumentu, data, powód zniszczenia)",
          "  • Edytowalna tabela produktów:",
          "    - Nazwa, ilość, cena netto, jednostka miary (SZT, KG, L)",
          "    - Wybór stawki VAT (0%, 5%, 8%, 23%)",
          "    - Auto-przeliczanie: wart. netto = ilość × cena",
          "    - Auto-przeliczanie: wart. brutto = netto + VAT",
          "  • Dodawanie nowych produktów (przycisk ➕)",
          "  • Usuwanie produktów (przycisk 🗑️)",
          "  • Pole podpisu (osoba sporządzająca)",
          "  • Pole 'Słownie' (kwota brutto słownie)",
          "",
          "💰 Automatyczne przeliczanie sum:",
          "  • Total netto - suma wszystkich wartości netto",
          "  • Total VAT - suma wszystkich kwot VAT",
          "  • Total brutto - suma wszystkich wartości brutto",
          "  • Breakdown per stawka VAT:",
          "    - 5%: netto, VAT, brutto",
          "    - 8%: netto, VAT, brutto",
          "    - 23%: netto, VAT, brutto",
          "",
          "📄 Generowanie PDF (ReportLab):",
          "  • Pixel-perfect odwzorowanie layoutu oryginału",
          "  • Pełna obsługa polskich znaków (fonty Liberation)",
          "  • Polski format liczb (przecinek jako separator)",
          "  • Tabelki podsumowania VAT (czytelne, bez zamazań)",
          "  • Sekcja końcowa z kwotą i kwotą słownie",
          "  • Brak niepotrzebnych elementów ('Pieczątka firmowa')",
          "",
          "💾 Zarządzanie protokołami:",
          "  • Zapisywanie wersji roboczych (💾 Zapisz roboczo)",
          "  • Historia wszystkich protokołów",
          "  • Status: Draft (wersja robocza) vs Final (wygenerowany)",
          "  • Pobieranie wygenerowanych PDF",
          "  • Usuwanie protokołów",
          "",
          "🔧 Integracje:",
          "  • MongoDB - przechowywanie protokołów",
          "  • Emergent LLM Key - OpenAI Vision (OCR)",
          "  • pdfplumber - parsowanie tekstowych PDF",
          "  • ReportLab - generowanie PDF"
        ]
      },
      {
        category: "🎨 Poprawki UI/UX",
        items: [
          "✅ Tabelki podsumowania VAT w PDF teraz w pełni czytelne",
          "  • Zmieniono rendering z Table() na bezpośrednie rysowanie",
          "  • Czytelne nagłówki i wartości liczbowe",
          "  • Prawidłowe wyrównanie (prawo dla liczb)",
          "",
          "✅ Poprawiono wyświetlanie kwot w PDF:",
          "  • Sekcja 'RAZEM' pokazuje pełną kwotę brutto",
          "  • Pole 'Słownie' edytowalne w formularzu",
          "  • Polski format liczb (przecinek jako separator)"
        ]
      }
    ],
    improvements: [
      "⚡ Zoptymalizowano parsowanie PDF (dwupoziomowe: pdfplumber + Vision OCR)",
      "🔐 Protokoły dostępne tylko dla Managera (uprawnienia)",
      "📱 Responsywny design formularza edycji",
      "💾 Auto-zapis przy każdej zmianie produktów",
      "🔄 Real-time przeliczanie sum przy edycji"
    ]
  },
  {
    version: "v2.1.1",
    date: "2026-04-12",
    title: "🔐 Zabezpieczenie wzorem & Nowości w nowym designie",
    features: [
      {
        category: "🔥 Szybkie dodanie straty (NOWE!)",
        items: [
          "✅ Nowa funkcja: Szybkie dodawanie strat z ekranu logowania (BEZ potrzeby logowania!)",
          "  • Przycisk '🔥 Szybkie dodanie straty' pod formularzem logowania",
          "  • Pełny formularz dodawania strat (kategorie, produkty, ilości)",
          "  • Automatyczne oznaczenie jako 'Kuchnia'",
          "  • Ekran sukcesu z podsumowaniem",
          "  • Uproszczony przepływ - usunięto pole 'Notatki'",
          "",
          "🔐 Zabezpieczenie wzorem (Pattern Lock 3x3):",
          "  • Wzór graficzny jak w telefonach Android",
          "  • Minimum 4 punkty wymagane",
          "  • Osobny wzór dla każdej lokalizacji (Kraków / Nowy Sącz)",
          "  • Przechowywanie w localStorage",
          "  • Brak wzoru = brak dostępu do formularza",
          "",
          "⚙️ Zarządzanie wzorem w Ustawieniach:",
          "  • Nowa sekcja: '🔐 Zabezpieczenie strat kuchennych'",
          "  • Status wzoru (aktywny ✅ / brak ⚠️)",
          "  • Ustawianie nowego wzoru (z potwierdzeniem)",
          "  • Zmiana istniejącego wzoru",
          "  • Usuwanie wzoru (z potwierdzeniem)",
          "  • Informacje o aktywnej lokalizacji"
        ]
      },
      {
        category: "✨ Nowości w nowym designie MR JERRY",
        items: [
          "📰 Przycisk 'Zobacz nowości' na ekranie wyboru lokalizacji:",
          "  • Złoty gradient (#d4af37) pasujący do MR JERRY",
          "  • Box-shadow ze złotym świeceniem",
          "  • Hover effects (podniesienie + scale)",
          "  • Ikony: 📰 i ✨",
          "",
          "📋 Modal Changelog - kompletny redesign:",
          "  • Złoty gradient w headerze",
          "  • Animowany shimmer effect",
          "  • Sidebar ze złotymi akcentami",
          "  • Badge 'NAJNOWSZA' w złotym gradiencie",
          "  • Sekcje Features/Improvements ze złotymi borderami",
          "  • Ciemne tło z subtelnym gradientem",
          "  • Float animation dla ikony",
          "  • Spójny design ze stylem ekranu logowania"
        ]
      }
    ],
    improvements: [
      "🎨 Unified design language - wszystkie elementy w stylu MR JERRY (złote gradienty)",
      "🔒 Zwiększone bezpieczeństwo - wzór chroni przed nieautoryzowanym dodawaniem strat",
      "⚡ Szybsze dodawanie strat - nie trzeba się logować (z zabezpieczeniem wzorem)",
      "🎯 Uproszczony formularz - usunięto zbędne pole 'Notatki'"
    ]
  },
  {
    version: "v2.0.0",
    date: "2026-04-11",
    title: "💰 MODUŁ SPRZEDAŻ - Kompletny System Szkoleniowy (NOWY MODUŁ!)",
    features: [
      {
        category: "🎯 MODUŁ SPRZEDAŻ - Faza 1 MVP (NOWY!)",
        items: [
          "🎉 Kompletny system szkoleniowy i sprzedażowy dla kelnerów!",
          "",
          "⚙️ Panel Managera (8 sekcji CRUD):",
          "  • 📖 Regułki sprzedażowe - zasady i najlepsze praktyki",
          "  • ❓ Pytania testowe - quiz wielokrotnego wyboru z wyjaśnieniami",
          "  • 🎭 Scenariusze sprzedażowe - sytuacje z gośćmi i najlepsze reakcje",
          "  • ✅ Zadania wdrożeniowe - codzienne zadania na zmianę",
          "  • 🥩 Produkty - baza produktów z cechami i tekstami sprzedażowymi",
          "  • 💬 Teksty sprzedażowe - gotowe skrypty rozmów",
          "  • 👥 Kelnerzy - opcjonalna lista kelnerów (NOWE!)",
          "  • ⚙️ Ustawienia - konfiguracja punktów i celów",
          "",
          "👨‍🍳 Widoki dla kelnerów (7 komponentów):",
          "  • 🏠 Dashboard - status treningu, cele, ranking, produkt dnia",
          "  • 📚 Trening dnia - 4-krokowy codzienny trening (2-3 min):",
          "    → Regułka dnia → Pytanie testowe → Scenariusz → Zadanie na zmianę",
          "  • 📊 Dodaj wyniki - formularz dziennych wyników zmiany",
          "  • 📈 Moje statystyki - analityka 7/14/30 dni z dynamicznymi tipami",
          "  • 🏆 Ranking - porównanie z innymi kelnerami (dzień/tydzień/miesiąc)",
          "  • 📖 Regułki - filtrowana baza wiedzy sprzedażowej",
          "  • 🥩 Produkty - katalog z tekstami sprzedażowymi",
          "",
          "📊 Automatyczne metryki:",
          "  • Średnia rachunek",
          "  • Wskaźnik dodatków (cel: ≥80%)",
          "  • Wskaźnik sosów",
          "  • Ranking kelnerów",
          "  • Historiadanych z wykresami",
          "",
          "✅ 11 grup endpointów backendu (837 linii API):",
          "  • Rules, Questions, Scenarios, Tasks, Products, Scripts, Settings (CRUD)",
          "  • Waiters (zarządzanie listą kelnerów)",
          "  • Training (codzienny trening)",
          "  • Results (wyniki zmian)",
          "  • Ranking (porównanie kelnerów)",
          "  • Dashboard (podsumowanie dla kelnera)"
        ]
      },
      {
        category: "🔄 System hybrydowy wyboru kelnerów (NOWE!)",
        items: [
          "✅ Elastyczny system logowania bez wymagania osobnych kont",
          "",
          "Dla Managera:",
          "  • Nowa zakładka '👥 Kelnerzy' w Panelu Managera",
          "  • Opcjonalna lista kelnerów (imię i nazwisko)",
          "  • Avatary z inicjałami",
          "  • Dodawanie/usuwanie kelnerów",
          "",
          "Dla kelnerów:",
          "  • 📋 Wybór z listy (dropdown) - jeśli manager dodał kelnerów",
          "  • ✍️ Wpisz ręcznie - zawsze dostępne dla nowych",
          "  • 💾 localStorage - zapamiętanie wybranego kelnera",
          "  • 🔄 Przycisk 'Zmień kelnera' - w nagłówku modułu",
          "",
          "Przepływ:",
          "  1. Pierwsze wejście → wybór kelnera (lista lub ręcznie)",
          "  2. Imię zapisuje się w localStorage",
          "  3. Kolejne sesje → auto-login z nazwiskiem",
          "  4. 'Zmień kelnera' → clear → nowy wybór",
          "",
          "💡 Idealne dla współdzielonych tabletów w restauracji!"
        ]
      },
      {
        category: "📈 Statystyki i analityka",
        items: [
          "✅ localStorage Session Management:",
          "  • Klucz lokalizacji: sales_waiter_name_{location}",
          "  • Persistence między sesjami",
          "  • Brak wymagania kont użytkowników",
          "",
          "✅ Tracking wyników:",
          "  • Automatyczne obliczanie metryk",
          "  • Średnia rachunek, wskaźnik dodatków, wskaźnik sosów",
          "  • Grupowanie po kelnerach (waiterName)",
          "  • Izolacja danych po lokalizacji",
          "",
          "✅ Moje statystyki - szczegółowy widok:",
          "  • Karty podsumowania (6 metryk)",
          "  • Tabela historii wyników z podświetleniem",
          "  • Dynamiczne wskazówki do poprawy",
          "  • Wybór okresu: 7/14/30 dni"
        ]
      }
    ],
    improvements: [
      "⚡ Kompletny system szkoleniowy bez wymagania kont dla kelnerów",
      "⚡ Hybrydowy wybór kelnera - z listy lub ręcznie",
      "⚡ localStorage session management - zapamiętanie kelnera",
      "⚡ Przycisk 'Zmień kelnera' dla współdzielonych urządzeń",
      "⚡ Automatyczne obliczanie wszystkich metryk sprzedażowych",
      "⚡ Dynamiczne tipy do poprawy dla każdego kelnera",
      "⚡ Premium steakhouse design - ciemne tła, złote akcenty"
    ],
    technicalNotes: [
      "Backend: /app/backend/routes/sales.py (837 linii - 11 grup endpointów)",
      "Frontend: 27 nowych komponentów (manager panel + waiter views)",
      "MongoDB: 10 nowych kolekcji (sales_*, sales_waiters)",
      "Testing: 53/53 testy backendowe zaliczone (100%)",
      "Dokumentacja: /app/RELEASE_NOTES.md (pełna specyfikacja v2.0)",
      "Wszystkie komponenty bez błędów lintingu",
      "E2E flows zweryfikowane przez testing subagent",
      "localStorage key pattern: sales_waiter_name_{location}"
    ],
    nextSteps: [
      "🟡 Faza 2: Rozbudowa produktów (zdjęcia, kategorie, alergeny)",
      "🟡 Faza 2: System rekomendacji 'Co polecać razem'",
      "🔵 Faza 2: Integracja skryptów z treningiem",
      "🔵 Backlog: Kalkulator zestawu, Produkt dnia",
      "🔮 Faza 3: Gamifikacja (odznaki, poziomy, wyzwania)",
      "🔮 Faza 4: Analityka managera (wykresy, raporty)",
      "🔮 Faza 5: Integracja POS + AI"
    ]
  },
  {
    version: "v1.19.0",
    date: "2026-04-08",
    title: "📱 Optymalizacja Mobile + 📄 PDF Formularzy + 💾 Rozszerzony Backup",
    features: [
      {
        category: "📱 NAPRAWA: Optymalizacja nawigacji mobilnej",
        items: [
          "✅ Usunięto duplikujące się elementy nawigacji na mobile",
          "  • Problem: Dwa hamburgery (lewy i prawy) + dolny pasek nawigacji",
          "  • Rozwiązanie: Tylko jeden hamburger menu po lewej stronie",
          "",
          "🔧 Zmiany w interfejsie mobile:",
          "  • Hamburger menu przeniesiony na LEWĄ stronę (standard UX)",
          "  • Usunięto BottomNav (dolny pasek z ikonami)",
          "  • Menu wysuwa się z lewej strony",
          "  • Header pokazuje hamburger tylko na desktop (toggle sidebar)",
          "",
          "✨ Rezultat:",
          "  • Czysty i intuicyjny interfejs mobilny",
          "  • Brak nakładających się elementów",
          "  • Lepsze wykorzystanie przestrzeni ekranu",
          "  • Zgodność ze standardami mobile UX"
        ]
      },
      {
        category: "📄 NOWA FUNKCJA: Pobieranie formularzy jako PDF",
        items: [
          "🎉 Możliwość eksportu formularzy pracowniczych do PDF!",
          "",
          "📥 Gdzie znajdziesz:",
          "  • Manager → Formularze → przycisk '📄 PDF' (w liście)",
          "  • Manager → Formularze → Szczegóły → '📄 Pobierz PDF' (duży przycisk)",
          "",
          "📋 Co zawiera PDF:",
          "  • Nagłówek z logo MR JERRY",
          "  • 👤 Dane osobowe (imię, nazwisko, data urodzenia, obywatelstwo, stanowisko)",
          "  • 🏠 Adres zamieszkania (ulica, kod, miasto, kraj)",
          "  • 📞 Dane kontaktowe (telefon, email)",
          "  • 💰 Dane do wypłaty (numer konta bankowego)",
          "  • 🏛️ Dane podatkowe (urząd skarbowy, pierwsza praca)",
          "  • 🎓 Status studenta (z dodatkowymi danymi jeśli dotyczy)",
          "  • ➕ Dane dodatkowe (kontakt awaryjny - opcjonalnie)",
          "  • 📝 Notatki managera (jeśli istnieją)",
          "  • Stopka z datą wygenerowania i statusem formularza",
          "",
          "💾 Format pliku:",
          "  • Nazwa: formularz_Imię_Nazwisko_YYYY-MM-DD.pdf",
          "  • Format: A4, orientacja pionowa",
          "  • Marginesy: 15mm",
          "  • Czcionka: Arial, czytelna",
          "",
          "🔧 Implementacja techniczna:",
          "  • Biblioteka: html2pdf.js (Canvas renderer)",
          "  • Safe access do wszystkich pól (brak błędów)",
          "  • Poprawne kolory tekstu (color: #000 dla wartości)",
          "  • Obsługa brakujących danych (fallback na '-')",
          "",
          "✅ Zastosowania:",
          "  • Archiwizacja formularzy pracowniczych",
          "  • Wysyłka do działu HR",
          "  • Drukowanie dla teczek osobowych",
          "  • Backup poza systemem"
        ]
      },
      {
        category: "💾 ROZSZERZENIE: Kompletny backup aplikacji",
        items: [
          "🔍 Znaleziono i naprawiono brakujące dane w backupie!",
          "",
          "❌ Problem:",
          "  • Backup NIE zawierał 2 ważnych kolekcji:",
          "    - form_access_codes (kody dostępu do formularzy)",
          "    - training_categories (kategorie szkoleń)",
          "",
          "✅ Rozwiązanie:",
          "  • Dodano form_access_codes do backup/restore",
          "  • Dodano training_categories do backup/restore",
          "",
          "📊 Backup teraz zawiera 26 kolekcji:",
          "",
          "  Podstawowe:",
          "  • waiters (pracownicy)",
          "  • entries (wpisy napiwków)",
          "  • closedDays (zamknięte dni)",
          "  • users (użytkownicy)",
          "",
          "  Billard & Odzież:",
          "  • billard, clothing, clothingTypes, jobPositions",
          "",
          "  Szkła:",
          "  • glassTypes, glassInventory",
          "",
          "  Kuchnia:",
          "  • products, kitchenLosses, beerCleaning",
          "",
          "  Szkolenia:",
          "  • trainingMenu, trainingQuizzes, trainingResults",
          "  • trainingMaterials, materialCategories",
          "  • trainingCategories ✨ NOWE",
          "",
          "  Inne:",
          "  • deliveries (Kraków), promotions",
          "  • employeeForms (formularze pracowników)",
          "  • formAccessCodes (kody dostępu) ✨ NOWE",
          "",
          "  Logi:",
          "  • auditLog (dziennik audytu)",
          "  • systemLogs (logi systemowe)",
          "",
          "✅ Funkcje backup:",
          "  • Auto-save: Automatycznie zapisuje kopie (max 30)",
          "  • Export: Pobierz plik JSON z wszystkimi danymi",
          "  • Restore: Przywróć dane z backupu",
          "  • Lista: Zobacz wszystkie dostępne kopie",
          "",
          "🎯 Rezultat:",
          "  • Backup jest teraz 100% kompletny",
          "  • Wszystkie zakładki i dane są zabezpieczone",
          "  • Można bezpiecznie przywrócić całą aplikację"
        ]
      }
    ],
    bugFixes: [
      "🐛 Naprawiono renderowanie danych w PDF formularzy (dodano explicit color: #000)",
      "🐛 Usunięto duplikujące się elementy nawigacji na ekranach mobilnych",
      "🐛 Poprawiono optional chaining dla wszystkich pól w generatorze PDF"
    ],
    improvements: [
      "⚡ Optymalizacja UX mobilnego - czystszy interfejs",
      "⚡ Lepsze wykorzystanie przestrzeni ekranu na mobile",
      "⚡ Kompletny backup - wszystkie dane aplikacji",
      "⚡ Profesjonalne PDF formularzy z pełnymi danymi"
    ]
  },
  {
    version: "v1.18.0",
    date: "2026-04-07",
    title: "📥 Import Quizów z XML (ChatGPT Integration)",
    features: [
      {
        category: "✅ NOWA FUNKCJA: Import Quizów z pliku XML",
        items: [
          "🎉 Możliwość generowania quizów w ChatGPT i importu do aplikacji!",
          "",
          "📥 Backend (training.py):",
          "  • POST /api/training/quiz/import-xml",
          "  • Parser XML (xml.etree.ElementTree)",
          "  • Walidacja struktury pliku",
          "  • Automatyczne tworzenie quiz ID",
          "  • Zapisywanie do MongoDB (training_quizzes)",
          "",
          "🎨 Frontend (SettingsTab):",
          "  • Nowa sekcja: '📥 Import Quizu z XML'",
          "  • QuizXMLImportSection.jsx component",
          "  • File upload input (tylko .xml)",
          "  • Kategoria quizu (input)",
          "  • Touch-friendly na mobile (48px)",
          "  • Przykładowy format XML w details",
          "  • Prompt dla ChatGPT",
          "",
          "📋 Format XML:",
          "  <quiz>",
          "    <title>Nazwa Quizu</title>",
          "    <description>Opis (opcjonalnie)</description>",
          "    <questions>",
          "      <question>",
          "        <text>Pytanie?</text>",
          "        <answer>Poprawna odpowiedź</answer>",
          "      </question>",
          "    </questions>",
          "  </quiz>",
          "",
          "💡 Workflow:",
          "  1. Otwórz ChatGPT",
          "  2. Prompt: 'Wygeneruj quiz o [temat] w formacie XML...'",
          "  3. Skopiuj XML do pliku .xml",
          "  4. Przejdź do Ustawienia → Import Quizu",
          "  5. Wybierz plik XML",
          "  6. Wpisz kategorię (np. 'Koktajle')",
          "  7. Kliknij 'Importuj Quiz'",
          "  8. Quiz dostępny w zakładce Szkolenia!",
          "",
          "✅ Walidacja:",
          "  • Sprawdzanie struktury XML",
          "  • Wymagane: <questions>, <question>, <text>, <answer>",
          "  • Puste pytania/odpowiedzi odrzucane",
          "  • Toast notifications z błędami",
          "",
          "📂 Przykładowy plik:",
          "  • /app/quiz_example.xml - 10 pytań o koktajlach",
          "  • Gotowy do użycia jako template"
        ]
      }
    ],
    technicalNotes: [
      "Backend: /app/backend/routes/training.py - import_quiz_from_xml endpoint",
      "Frontend: /app/frontend/src/components/settings/QuizXMLImportSection.jsx",
      "SettingsTab.jsx: Added QuizXMLImportSection import & render",
      "XML Parser: xml.etree.ElementTree (Python standard library)",
      "File upload: FormData + multipart/form-data",
      "Quiz storage: MongoDB training_quizzes collection",
      "Quiz ID format: quiz_{location}_{YYYYMMDD_HHMMSS}",
      "Example file: /app/quiz_example.xml (cocktails quiz)"
    ]
  },
  {
    version: "v1.17.1",
    date: "2026-04-07",
    title: "🐛 Fix: Uprawnienia - Materiały i inne",
    features: [
      {
        category: "✅ Bug Fix: System Uprawnień",
        items: [
          "🐛 NAPRAWIONO: Uprawnienia 'Materiały' nie zapisywały się",
          "",
          "Problem:",
          "  • Frontend wysyłał: 'materials' (pojedyncze uprawnienie)",
          "  • Backend akceptował: 'materials_view', 'materials_create', 'materials_edit', 'materials_delete'",
          "  • Uprawnienie było odrzucane przez backend",
          "",
          "Rozwiązanie:",
          "  ✅ Zaktualizowano managerUtils.js - granular permissions",
          "  ✅ Frontend teraz wysyła: materials_view, materials_create, materials_edit, materials_delete",
          "  ✅ To samo dla Zakupy (deliveries): deliveries_view, deliveries_create, deliveries_edit, deliveries_delete",
          "  ✅ Dodano brakujące uprawnienia: beer_cleaning, promotions, canVerifyTests",
          "",
          "📋 Pełna lista uprawnień (22 total):",
          "  1. tips - Napiwki",
          "  2. summary - Podsumowanie",
          "  3. employees - Pracownicy",
          "  4. reports - Raporty",
          "  5. billard - Bilard",
          "  6. glass - Szkło",
          "  7. kitchen_losses - Straty",
          "  8. clothing - Ubrania",
          "  9. training - Szkolenia",
          "  10. materials_view - Materiały (widok)",
          "  11. materials_create - Materiały (tworzenie)",
          "  12. materials_edit - Materiały (edycja)",
          "  13. materials_delete - Materiały (usuwanie)",
          "  14. deliveries_view - Zakupy (widok)",
          "  15. deliveries_create - Zakupy (tworzenie)",
          "  16. deliveries_edit - Zakupy (edycja)",
          "  17. deliveries_delete - Zakupy (usuwanie)",
          "  18. beer_cleaning - Czyszczenie piwa",
          "  19. promotions - Promocje",
          "  20. export - Eksport",
          "  21. settings - Ustawienia",
          "  22. canVerifyTests - Weryfikacja testów",
          "",
          "💡 Teraz możesz precyzyjnie kontrolować:",
          "  • Kto może WIDZIEĆ materiały vs KTO MOŻE je TWORZYĆ/EDYTOWAĆ/USUWAĆ",
          "  • To samo dla Zakupów (deliveries)",
          "  • Wszystkie uprawnienia działają poprawnie"
        ]
      }
    ],
    technicalNotes: [
      "managerUtils.js: Updated availablePermissions array (22 items)",
      "AllEmployeesSection.jsx: Updated permissionLabels mapping",
      "Backend validation: All 22 permissions now match frontend",
      "Granular control: materials & deliveries split into view/create/edit/delete"
    ]
  },
  {
    version: "v1.17.0",
    date: "2026-04-07",
    title: "🎨 Mobile UX - FormWizard dla Employee Form",
    features: [
      {
        category: "✅ NAJWIĘKSZA ZMIANA UX: Employee Form → 8-Step Wizard (Mobile)",
        items: [
          "✅ EmployeeFormWizard.jsx - nowy komponent",
          "  • Mobile (<768px): Multi-step wizard z 8 krokami",
          "  • Desktop (≥768px): Oryginalny długi formularz",
          "  • Auto-switch based on useIsMobile()",
          "",
          "📋 8 Kroków Formularza (Mobile):",
          "  1. ✅ Dane osobowe (Imię, Nazwisko, Data urodzenia, Stanowisko, Umowa)",
          "  2. ✅ Adres zamieszkania (Ulica, Kod, Miasto, Kraj)",
          "  3. ✅ Kontakt (Telefon, Email)",
          "  4. ✅ Dane do wypłaty (Numer konta bankowego)",
          "  5. ✅ Dane podatkowe (Urząd skarbowy, Pierwsza praca)",
          "  6. ✅ Status studenta (Checkbox + Uczelnia, Kierunek, Ważność legitymacji)",
          "  7. ✅ Kontakt awaryjny (Imię, Telefon)",
          "  8. ✅ Oświadczenia (11 wymaganych checkboxów)",
          "",
          "🎯 UX Improvements (Mobile):",
          "  • Progress bar: 'Krok X z 8'",
          "  • Sticky navigation (Wstecz / Dalej)",
          "  • Per-step validation (nie można iść dalej bez wypełnienia)",
          "  • Smooth scroll między krokami",
          "  • Znacznie łatwiejsze wypełnienie na małym ekranie",
          "  • Touch-friendly inputs (48px)",
          "  • No overwhelming - jeden krok na raz",
          "",
          "🔐 Access Code Integration:",
          "  • Code verification screen przed formularzem",
          "  • 6-cyfrowy kod input",
          "  • Weryfikacja API przed dostępem do kroków",
          "",
          "💡 Technical:",
          "  • EmployeeFormModal.jsx: Conditional rendering",
          "  • Mobile → EmployeeFormWizard (8 steps)",
          "  • Desktop → Original long form (zachowane dla kompatybilności)",
          "  • Używa TouchInput components",
          "  • Używa FormWizard component (created in v1.15.0)",
          "  • Full data compatibility - te same pola, ten sam submit endpoint"
        ]
      }
    ],
    technicalNotes: [
      "EmployeeFormWizard.jsx: New 8-step wizard component (393 lines)",
      "EmployeeFormModal.jsx: Added useIsMobile() conditional rendering",
      "FormWizard.jsx: Reused from v1.15.0 infrastructure",
      "TouchInput.jsx: Reused for all form inputs",
      "All 11 declarations (oświadczenia) included in step 8",
      "Per-step validation with toast.error() feedback",
      "Submit endpoint: POST /api/forms (unchanged)"
    ]
  },
  {
    version: "v1.16.0",
    date: "2026-04-07",
    title: "📱 Full Mobile Optimization - COMPLETE!",
    features: [
      {
        category: "✅ FAZY 3-6: Tables, Forms, Modals (UKOŃCZONE)",
        items: [
          "✅ FAZA 3: Table Optimization",
          "  • SummaryTab → ResponsiveTable",
          "  • Mobile: Card layout z touch-friendly buttons",
          "  • Desktop: Sticky first column table",
          "  • Auto-switch <768px",
          "",
          "✅ FAZA 4: Forms Touch-Friendly",
          "  • Global CSS: All inputs min-height: 48px",
          "  • Global CSS: All buttons min-height: 48px",
          "  • Font-size: 16px (prevent iOS auto-zoom)",
          "  • Checkboxes/radios: 24px min touch area",
          "  • Applies to ALL forms across app (LoginScreen, TipsTab, Settings, etc.)",
          "",
          "✅ FAZA 5: Modals Responsive",
          "  • ResponsiveModal component ready",
          "  • Full-screen na mobile, centered na desktop",
          "",
          "💡 UX Improvements:",
          "  • Tabele łatwo scrollowalne jako karty na telefonie",
          "  • Wszystkie inputy łatwe do wypełnienia (nie ma zoom)",
          "  • Przyciski wystarczająco duże do klikania palcem",
          "  • Checkboxy łatwe do zaznaczenia",
          "  • Native mobile feel w całej aplikacji"
        ]
      }
    ],
    technicalNotes: [
      "SummaryTab.jsx: Converted to ResponsiveTable with custom columns",
      "App.css: Added global mobile styles for inputs/buttons (min-height: 48px)",
      "App.css: Font-size: 16px on mobile (prevent iOS zoom)",
      "App.css: Checkbox/radio touch targets (24px)",
      "ResponsiveTable: Handles deleted entries styling",
      "All forms now touch-friendly without individual refactoring"
    ]
  },
  {
    version: "v1.15.1",
    date: "2026-04-07",
    title: "📱 Mobile Navigation - ZINTEGROWANA",
    features: [
      {
        category: "✅ FAZA 2-B: Mobile Navigation (COMPLETE)",
        items: [
          "✅ Bottom Navigation Bar zintegrowany z App.js",
          "  • Sticky nav na dole ekranu (tylko mobile <768px)",
          "  • Auto-switch: Home, Napiwki, Raporty, Menu",
          "  • Różne itemy dla managera vs pracownika",
          "  • Touch-friendly (48px), złoty indicator",
          "",
          "✅ Hamburger Menu zintegrowany z App.js",
          "  • Slide-out panel z pełną listą zakładek",
          "  • Generowanie menu items based on permissions",
          "  • Location-aware (Kraków/Nowy Sącz specific items)",
          "  • Animated icon (☰ → ✕)",
          "",
          "✅ Desktop Navbar ukryty na mobile",
          "  • Conditional rendering based on `useIsMobile()`",
          "  • Sidebar hidden <768px",
          "",
          "✅ Layout responsive adjustments",
          "  • main-content: padding-bottom: 100px (mobile)",
          "  • Przestrzeń dla Bottom Nav (72px + padding)",
          "  • No content overlap",
          "",
          "💡 UX Improvements:",
          "  • Łatwy dostęp kciukiem (bottom nav)",
          "  • Pełne menu dostępne jednym kliknięciem",
          "  • Płynne transitions i animacje",
          "  • Native mobile feel"
        ]
      }
    ],
    technicalNotes: [
      "App.js: Imported BottomNav, HamburgerMenu, useIsMobile",
      "App.js: Added isHamburgerOpen state",
      "App.js: Conditional Navbar rendering (!isMobile)",
      "App.js: Menu items generation based on hasPermission + location",
      "App.css: .main-content padding-bottom: 100px on mobile",
      "utils/mobileNavHelpers.js: Helper functions for menu generation"
    ]
  },
  {
    version: "v1.15.0",
    date: "2026-04-07",
    title: "📱 Pełna Optymalizacja Mobilna - Foundation",
    features: [
      {
        category: "🏗️ Mobile-First Infrastructure",
        items: [
          "✅ NOWY: Kompletny system responsywności mobilnej",
          "",
          "📐 CSS Variables & Design System:",
          "  • Pełna paleta kolorów: --bg-base, --bg-surface, --text-primary, --gold",
          "  • Typography scale: --font-heading (Manrope), --font-body (IBM Plex Sans)",
          "  • Spacing system: --space-xs do --space-2xl",
          "  • Touch targets: --touch-target-min (48px)",
          "  • Border radius: --radius-sm do --radius-full",
          "  • Shadows & effects: --shadow-gold, --shadow-lg",
          "  • Z-index scale: kompletna hierarchia warstw",
          "",
          "📱 Responsive Breakpoints:",
          "  • Mobile: <768px (telefony)",
          "  • Tablet: 768px-1023px",
          "  • Desktop: ≥1024px",
          "",
          "📊 Responsive Typography:",
          "  • Mobile: h1=24px, h2=20px, body=14px",
          "  • Desktop: h1=32px, h2=24px, body=16px"
        ]
      },
      {
        category: "🧩 Nowe Komponenty Mobilne",
        items: [
          "✅ BottomNav.jsx - Bottom Navigation Bar",
          "  • Nawigacja sticky na dole ekranu (tylko mobile)",
          "  • 4 główne akcje: Home, Napiwki, Raporty, Menu",
          "  • Touch-friendly (48px min height)",
          "  • Aktywny tab z złotym wskaźnikiem na górze",
          "  • Haptic feedback (scale on touch)",
          "",
          "✅ HamburgerMenu.jsx - Slide-out Menu",
          "  • Przycisk hamburger w prawym górnym rogu",
          "  • Slide-in panel z prawej strony (280px)",
          "  • Backdrop blur & click-to-close",
          "  • Animated hamburger icon (3 kreski → X)",
          "  • Touch-friendly menu items (48px)",
          "",
          "✅ ResponsiveTable.jsx - Adaptive Tables",
          "  • Mobile: Card-based layout",
          "  • Desktop: Standard table ze sticky pierwszą kolumną",
          "  • Touch-friendly cards z visual feedback",
          "  • Auto-switch między layoutami",
          "",
          "✅ TouchInput.jsx - Touch-Friendly Forms",
          "  • TouchInput: 48px min height, large touch area",
          "  • TouchButton: 3 variants (primary, secondary, danger)",
          "  • TouchSelect: Mobile-optimized dropdown",
          "  • Auto-scaling fonts dla mobile (16px min - prevent iOS zoom)",
          "  • Visual feedback on focus/touch",
          "",
          "✅ ResponsiveModal.jsx - Adaptive Modals",
          "  • Mobile: Full-screen z sticky header/footer",
          "  • Desktop: Centered dialog",
          "  • Slide-up animation na mobile",
          "  • Touch-friendly close button (48px)",
          "  • Scrollable content area",
          "",
          "✅ FormWizard.jsx - Multi-Step Forms",
          "  • Progress bar z aktualnym krokiem",
          "  • Sticky navigation (Wstecz/Dalej)",
          "  • Smooth scroll między krokami",
          "  • Walidacja per-step",
          "  • Idealne dla Employee Form (8 kroków)",
          "",
          "✅ useMediaQuery.js - Breakpoint Detection",
          "  • Custom hook: useMediaQuery(query)",
          "  • Predefined: useIsMobile(), useIsTablet(), useIsDesktop()",
          "  • Real-time responsive updates",
          "  • Legacy browser support"
        ]
      },
      {
        category: "🎨 Design Guidelines",
        items: [
          "✅ design_guidelines.json - 112 linijek specyfikacji",
          "  • Kompletny plan responsywności dla całej aplikacji",
          "  • Wytyczne dla nawigacji, tabel, formularzy, modali",
          "  • Breakpointy, typography, spacing, colors",
          "  • Ready-to-implement blueprint"
        ]
      }
    ],
    technicalNotes: [
      "CSS: index.css - Complete design system with CSS variables",
      "Hooks: useMediaQuery.js - Responsive breakpoint detection",
      "Components: 7 new mobile-optimized components created",
      "Touch-friendly: All interactive elements ≥48px",
      "Performance: Lazy loading & optimized re-renders",
      "Accessibility: Proper ARIA labels & keyboard navigation",
      "Foundation for integrating mobile components into existing tabs"
    ],
    nextSteps: [
      "FAZA 2-B: Integracja Bottom Nav & Hamburger Menu w App.js",
      "FAZA 3: Refaktor wszystkich tabel (Podsumowanie, Szkła, Odzież, etc.) na ResponsiveTable",
      "FAZA 4: Refaktor formularzy na TouchInput components",
      "FAZA 5: Konwersja wszystkich modali na ResponsiveModal",
      "FAZA 6: Employee Form → FormWizard (8-step flow)",
      "FAZA 7: Full testing na urządzeniach (320px, 375px, 414px, 768px, 1024px)"
    ]
  },
  {
    version: "v1.14.4",
    date: "2026-04-07",
    title: "✨ UX Improvement - Rozwijana Historia Kodów",
    features: [
      {
        category: "🎨 Usprawnienia UX w Zakładce Formularze",
        items: [
          "✅ NOWY: Rozwijana lista historii kodów",
          "  • Użyte i wygasłe kody ukryte w rozwijanej sekcji '📜 Historia kodów'",
          "  • Przycisk pokazuje liczbę kodów w historii (np. 'Historia kodów (9)')",
          "  • Strzałka wskaźnika: ▶ (zwinięte) / ▼ (rozwinięte)",
          "  • Płynna animacja przy rozwijaniu/zwijaniu",
          "",
          "🎯 Poprawa czytelności:",
          "  • Aktywne kody (🟢) zawsze widoczne na górze",
          "  • Kody historyczne (✅ Użyty / 🔴 Wygasły) domyślnie ukryte",
          "  • Mniejszy rozmiar czcionki w historii (18px vs 28px dla aktywnych)",
          "  • Bardziej przejrzysty interfejs zarządzania kodami",
          "",
          "💡 Korzyści:",
          "  • Mniej zaśmiecony widok formularzy",
          "  • Łatwiejsze znalezienie aktywnego kodu",
          "  • Historia dostępna na żądanie jednym kliknięciem"
        ]
      }
    ],
    technicalNotes: [
      "FormsSection.jsx: Added showCodeHistory state toggle",
      "Split codes into activeCodesList and historyCodesList",
      "History section with smooth fadeIn animation (0.3s)",
      "Compact history card design with smaller font and padding"
    ]
  },
  {
    version: "v1.14.3",
    date: "2026-04-07",
    title: "🔐 System Kodów Dostępu do Formularza",
    features: [
      {
        category: "🔑 Zabezpieczenie Formularza Pracownika",
        items: [
          "✅ NOWY: System 6-cyfrowych kodów dostępu",
          "  • Formularz pracownika wymaga teraz kodu dostępu",
          "  • Kody generowane przez Managera z ważnością 10 minut",
          "  • Zabezpieczenie przed nieautoryzowanymi zgłoszeniami",
          "",
          "🔑 Panel Managera (Zakładka 'Formularze'):",
          "  • Nowy przycisk: '🔑 Generuj kod'",
          "  • Wyświetlanie aktywnych kodów z odliczaniem czasu",
          "  • Statusy kodów: 🟢 Aktywny / ✅ Użyty / 🔴 Wygasły",
          "  • Lista ostatnio wygenerowanych kodów (ostatnia godzina)",
          "  • Każdy kod powiązany z konkretną lokalizacją",
          "",
          "🔐 Weryfikacja Kodu (Formularz Pracownika):",
          "  • Ekran wprowadzania kodu przed formularzem",
          "  • Walidacja 6-cyfrowego kodu",
          "  • Komunikaty błędów:",
          "    - 'Nieprawidłowy kod'",
          "    - 'Kod wygasł'",
          "    - 'Kod został już użyty'",
          "  • Po poprawnej weryfikacji → dostęp do formularza",
          "",
          "⚙️ Logika Biznesowa:",
          "  • Kody ważne przez 10 minut od wygenerowania",
          "  • Każdy kod może być użyty tylko raz",
          "  • Kod przypisany do lokalizacji (Kraków/Nowy Sącz)",
          "  • Automatyczne oznaczanie kodu jako 'użyty' po weryfikacji",
          "  • Live countdown dla aktywnych kodów"
        ]
      }
    ],
    technicalNotes: [
      "Backend: POST /api/forms/generate-access-code (Manager auth required)",
      "Backend: GET /api/forms/verify-access-code (Public endpoint)",
      "Backend: GET /api/forms/active-codes (Manager auth required)",
      "MongoDB collection: form_access_codes (code, location, expires_at, used, created_at)",
      "Frontend: FormsSection.jsx - code generation UI with live countdown",
      "Frontend: EmployeeFormModal.jsx - code verification flow before form access",
      "Access codes are location-aware and single-use"
    ]
  },
  {
    version: "v1.14.2",
    date: "2026-04-07",
    title: "📝 Formularz - Aktualizacja Pól",
    features: [
      {
        category: "✏️ Zmiany w Formularzu Pracownika",
        items: [
          "❌ USUNIĘTO: Pole PESEL",
          "  • Z powodów zgodności z RODO",
          "  • Nie jest już wymagane do zgłoszenia",
          "",
          "✅ DODANO: 'Jakie stanowisko' (pole tekstowe)",
          "  • Kandydat może wpisać dowolne stanowisko",
          "  • Przykłady: Kelner, Kucharz, Barman, Kierowca",
          "  • Pole wymagane - walidacja przy wysyłce",
          "",
          "✅ DODANO: 'Do kiedy umowa' (pole daty)",
          "  • Data do której przygotować umowę zlecenie",
          "  • Wybór daty z kalendarza",
          "  • Pole wymagane - walidacja przy wysyłce",
          "",
          "📊 Aktualizacja widoku managera:",
          "  • W szczegółach formularza wyświetlane są:",
          "    - Stanowisko (nowe pole)",
          "    - Umowa do (nowe pole, formatowanie polskie)",
          "  • PESEL nie jest już wyświetlany",
          "",
          "✅ Walidacja:",
          "  • Komunikat: 'Podaj stanowisko' - jeśli puste",
          "  • Komunikat: 'Podaj datę do kiedy umowa' - jeśli pusta"
        ]
      }
    ],
    technicalNotes: [
      "Updated PersonalData model: removed pesel, added desiredPosition and contractUntil",
      "Updated form validation in both EmployeeFormModal and EmployeeFormPage",
      "Updated manager view (FormsSection) to display new fields",
      "All changes verified through code review"
    ]
  },
  {
    version: "v1.14.1",
    date: "2026-04-07",
    title: "🎨 UX Update - Formularz jako Modal",
    features: [
      {
        category: "✨ Usprawnienia UX",
        items: [
          "✅ Formularz pracownika wyświetla się teraz jako modal/overlay",
          "✅ Brak przekierowania - pozostajesz na tej samej stronie",
          "✅ Identyczne zachowanie jak 'Załóż konto'",
          "✅ 3 sposoby zamknięcia modalu:",
          "  • Przycisk 'Anuluj'",
          "  • Przycisk ✕ w prawym górnym rogu",
          "  • Kliknięcie poza modal (na tło)",
          "✅ Płynne animacje otwarcia/zamknięcia",
          "✅ Auto-zamknięcie po wysłaniu formularza (1.5s)",
          "",
          "📊 Korzyści:",
          "  • Szybsze wypełnianie - nie trzeba wracać",
          "  • Lepsza orientacja - wiesz gdzie jesteś",
          "  • Spójne UX z resztą aplikacji",
          "  • Możliwość wielokrotnego otwierania bez przeładowania"
        ]
      }
    ],
    technicalNotes: [
      "Created EmployeeFormModal component (replaces page redirect)",
      "Added modal state management in LoginScreen",
      "Maintained all form functionality and validation",
      "All tests passed (modal display, form submission, closing behavior)"
    ]
  },
  {
    version: "v1.14.0",
    date: "2026-04-07",
    title: "📋 System Formularzy Pracowniczych + 💾 Backup Update",
    features: [
      {
        category: "📋 Nowy System Formularzy Rekrutacyjnych",
        items: [
          "🆕 NOWA FUNKCJA: Formularz pracownika bez konieczności logowania!",
          "",
          "✅ Dla kandydatów:",
          "  • Nowy przycisk '📋 Formularz' na ekranie wyboru lokalu",
          "  • Kompletny formularz rekrutacyjny (8 sekcji):",
          "    1. Dane osobowe (imię, nazwisko, PESEL, data urodzenia, obywatelstwo)",
          "    2. Adres zamieszkania (pełny adres)",
          "    3. Dane kontaktowe (telefon, email)",
          "    4. Dane do wypłaty (numer konta bankowego)",
          "    5. Dane podatkowe (urząd skarbowy, pierwsza praca)",
          "    6. Status zatrudnienia/nauki (uczeń/student + warunkowe pola):",
          "       → Szkoła/Uczelnia, kierunek, data ważności legitymacji",
          "       → Upload legitymacji (PDF, max 100MB)",
          "    7. Dane dodatkowe (kontakt awaryjny - opcjonalne)",
          "    8. Oświadczenia RODO (2 checkboxy wymagane)",
          "  • Walidacja wszystkich pól",
          "  • Wysyłka formularza bez tworzenia konta",
          "",
          "✅ Dla managerów:",
          "  • Nowa zakładka '📋 Formularze' w panelu Manager",
          "  • Lista wszystkich wypełnionych formularzy",
          "  • 5 filtrów statusu:",
          "    → 🟡 Do przejrzenia (domyślny)",
          "    → 👁️ Przejrzany",
          "    → ✅ Zaakceptowany",
          "    → ❌ Odrzucony",
          "  • Szczegółowy podgląd formularza (wszystkie 8 sekcji)",
          "  • Możliwość zmiany statusu (4 przyciski)",
          "  • Notatki managera (edycja i zapis)",
          "  • Podgląd załączonych dokumentów (PDF legitymacji)",
          "  • Usuwanie formularzy",
          "",
          "🔐 Bezpieczeństwo:",
          "  • Upload plików PDF (walidacja typu i rozmiaru)",
          "  • Maksymalny rozmiar załącznika: 100MB",
          "  • Formularze przypisane do lokalizacji",
          "",
          "📊 Korzyści:",
          "  • Uproszczony proces rekrutacji",
          "  • Zbieranie danych przed utworzeniem konta",
          "  • Centralna baza kandydatów",
          "  • Historia wszystkich aplikacji",
          "  • Łatwe filtrowanie i zarządzanie"
        ]
      },
      {
        category: "💾 Aktualizacja Systemu Backup",
        items: [
          "✅ Backup Version: 5 → 6",
          "",
          "🆕 Nowa kolekcja w backupie:",
          "  • employee_forms - Formularze rekrutacyjne pracowników",
          "",
          "📦 Pełne pokrycie backupu (23 kolekcje):",
          "  • Dane biznesowe (15 kolekcji)",
          "  • Dane szkoleniowe (5 kolekcji)",
          "  • Logi i audyt (2 kolekcje)",
          "  • Formularze rekrutacyjne (1 kolekcja) 🆕",
          "",
          "✅ Funkcje restore zaktualizowane:",
          "  • restore_backup() - przywraca formularze",
          "  • restore_from_archive() - przywraca z archiwum",
          "",
          "📊 Statystyki backupu rozszerzone o employeeForms"
        ]
      },
      {
        category: "🛠️ Usprawnienia Techniczne",
        items: [
          "Dodano React Router do aplikacji",
          "Nowy route: /formularz-pracownika",
          "9 nowych endpointów API dla formularzy",
          "Upload handling dla dużych plików PDF (do 100MB)",
          "Wszystkie testy przeszły pomyślnie (frontend + backend)",
          "Kod spełnia standardy produkcyjne"
        ]
      }
    ],
    technicalNotes: [
      "Added complete employee forms system with 9 API endpoints",
      "Implemented PDF upload with 100MB limit and validation",
      "Created FormsSection component with list and detail views",
      "Added employee_forms collection to backup system (version 6)",
      "Integrated React Router for /formularz-pracownika route",
      "All functionality tested and working (21/21 tests passed)"
    ]
  },
  {
    version: "v1.13.0",
    date: "2026-04-07",
    title: "🔧 Refaktoryzacja Kodu + 💾 Usprawnienie Backupu",
    features: [
      {
        category: "🎨 Refaktoryzacja Frontendu - Lepsza Czytelność Kodu",
        items: [
          "✅ Utworzono współdzielone funkcje pomocnicze w 'employeeHelpers.js':",
          "  • calculateAge() - obliczanie wieku z daty urodzenia",
          "  • getCategoryDisplayName() - nazwy kategorii z emoji",
          "  • formatBirthDate() - formatowanie daty urodzenia",
          "  • groupByCategory() - grupowanie pracowników",
          "",
          "✅ Rozbudowano centralne style w 'managerStyles.js':",
          "  • Dodano 15+ nowych stylów (filterButton, employeeCard, roleBadge, etc.)",
          "  • Karty urodzinowe (birthdayCardToday, birthdayCardUpcoming, birthdayCardYesterday)",
          "  • Style dla przycisków, formularzy i odznak",
          "",
          "✅ Zrefaktoryzowano 3 kluczowe komponenty:",
          "  • EmployeesTab.jsx - używa teraz 'useEditableWorker' hook zamiast lokalnych stanów",
          "  • AllEmployeesSection.jsx - wszystkie inline style zastąpione 'MANAGER_STYLES'",
          "  • WorkersSection.jsx - usunięto duplikację funkcji calculateAge",
          "",
          "📊 Rezultaty:",
          "  • Zredukowano ~150 linii duplikowanego kodu",
          "  • Łatwiejsze utrzymanie - zmiany stylów w jednym miejscu",
          "  • Modularny kod z współdzielonymi hookami i komponentami",
          "  • Wszystkie testy przeszły pomyślnie (21/21) ✅"
        ]
      },
      {
        category: "💾 Usprawnienie Funkcji Backup - Kompletna Ochrona Danych",
        items: [
          "⚠️ KRYTYCZNE: Dodano brakujące kolekcje do backupu!",
          "",
          "🆕 Nowe kolekcje w backupie:",
          "  • audit_log - Historia audytu (kto, kiedy, co zmienił w systemie)",
          "  • system_logs - Logi systemowe (zdarzenia, błędy, IP addresses, user agents)",
          "",
          "✅ Co to oznacza:",
          "  • Backup Version: 4 → 5",
          "  • Kolekcji w backupie: 20 → 22",
          "  • 100% danych biznesowych zabezpieczonych",
          "  • 100% historii audytu zabezpieczonych",
          "  • 100% logów systemowych zabezpieczonych",
          "",
          "📦 Pełne pokrycie backupu (22 kolekcje):",
          "  • Dane biznesowe (15): waiters, entries, users, clothing, glass, products, etc.",
          "  • Dane szkoleniowe (5): training_menu, quizzes, materials, categories",
          "  • Logi i audyt (2): audit_log ✨, system_logs ✨",
          "",
          "🔄 Zaktualizowane funkcje:",
          "  • get_backup() - pobiera audit_log i system_logs",
          "  • restore_backup() - przywraca obie nowe kolekcje",
          "  • restore_from_archive() - przywraca z archiwum",
          "",
          "🧪 Przetestowano:",
          "  • Backup generation ✅",
          "  • Auto-save to archive ✅",
          "  • Restore cycle (backup → delete → restore) ✅",
          "  • Działa dla Kraków i Nowy Sącz ✅"
        ]
      },
      {
        category: "🛠️ Usprawnienia Techniczne",
        items: [
          "Naprawiono ścieżki importów w WorkerCard.jsx",
          "Wyczyszczono niejednoznaczne zmienne w settings.py",
          "Wszystkie lintery przeszły pomyślnie (Python + JavaScript)",
          "Kod spełnia standardy produkcyjne"
        ]
      }
    ],
    technicalNotes: [
      "Backup version bumped to 5 (adds audit_log and system_logs)",
      "Refactored 3 manager components to use shared hooks and styles",
      "Created employeeHelpers.js with 5 reusable utility functions",
      "Extended managerStyles.js with 15+ new style definitions",
      "All 335+ system logs and audit entries now backed up automatically"
    ]
  },
  {
    version: "v1.12.0",
    date: "2026-04-07",
    title: "🔐 Security Update + 🎨 Minimalistyczny Header",
    features: [
      {
        category: "👥 Rejestracja Pracownika - ZMIANA",
        items: [
          "⚠️ ZMIANA: Rejestracja nowych pracowników wymaga teraz silnych haseł",
          "Hasło musi mieć minimum 8 znaków (wcześniej 4)",
          "Hasło musi zawierać wielką literę, małą literę i cyfrę",
          "Formularz rejestracji pokazuje wymagania i waliduje na żywo",
          "Manager otrzymuje jasne komunikaty o błędach po polsku",
          "Dotyczy: Manager → Zatwierdzanie pracowników → Rejestracja"
        ]
      },
      {
        category: "📝 Jak działa rejestracja pracownika (przypomnienie)",
        items: [
          "KROK 1: Pracownik rejestruje się sam przez formularz rejestracji",
          "- Podaje: imię, nazwisko, nazwę użytkownika, stanowisko, lokalizację",
          "- NIE ustawia hasła sam (hasło ustawi manager przy zatwierdzeniu)",
          "",
          "KROK 2: Manager widzi zgłoszenie w zakładce 'Manager → Zatwierdzanie pracowników'",
          "- Pojawia się lista oczekujących pracowników",
          "- Manager widzi wszystkie dane zgłoszenia",
          "",
          "KROK 3: Manager zatwierdza pracownika",
          "- Nadaje uprawnienia (np. canVerifyTests, canManageInventory)",
          "- ⚠️ NOWE: Ustawia silne hasło początkowe (min. 8 znaków, wielka/mała litera, cyfra)",
          "- Klika 'Zatwierdź' → pracownik może się zalogować",
          "",
          "KROK 4: Pracownik loguje się po raz pierwszy",
          "- Używa nazwy użytkownika i hasła ustawionego przez managera",
          "- Może zmienić hasło w swoim profilu (również na silne)",
          "",
          "⚠️ CO SIĘ ZMIENIŁO w v1.12.0:",
          "- Manager MUSI teraz ustawić silne hasło (nie może być '1234')",
          "- System nie pozwoli zatwierdzić ze słabym hasłem",
          "- Komunikaty błędów podpowiadają jak stworzyć prawidłowe hasło"
        ]
      },
      {
        category: "🔐 Bezpieczeństwo - Silne Hasła",
        items: [
          "Nowe wymagania haseł: minimum 8 znaków, wielka/mała litera, cyfra",
          "Walidacja przy rejestracji nowych pracowników",
          "Walidacja przy zmianie hasła przez managera",
          "Przejrzyste komunikaty błędów po polsku",
          "Utworzono `/backend/utils/password_validator.py`"
        ]
      },
      {
        category: "🛡️ Bezpieczeństwo - Rate Limiting",
        items: [
          "Ochrona przed atakami brute-force na login",
          "Limit: 5 prób logowania na minutę (z tego samego IP)",
          "Integracja slowapi library",
          "429 Too Many Requests po przekroczeniu limitu",
          "Automatyczne resetowanie po minucie"
        ]
      },
      {
        category: "♿ Accessibility (A11Y)",
        items: [
          "Focus styles dla nawigacji klawiaturą (złoty outline)",
          "Skip to main content link dla screen readerów",
          "ARIA utilities: ariaLabel(), ariaLive(), keyboardActivation()",
          "useFocusTrap() dla modali i dialogów",
          "Klasa .sr-only dla tekstu screen reader-only",
          "Plik: `/frontend/src/utils/accessibility.js`"
        ]
      },
      {
        category: "🔧 Naprawy Bugów",
        items: [
          "✅ NAPRAWIONO: Manager nie mógł zmieniać haseł pracowników",
          "Problem: Frontend wysyłał 'password', backend oczekiwał 'newPassword'",
          "Problem: Frontend używał PATCH, backend oczekiwał PUT",
          "Plik: `/frontend/src/components/manager/AllEmployeesSection.jsx`",
          "Status: Przetestowane przez testing agent (100% sukces)"
        ]
      },
      {
        category: "🔧 Naprawy Endpointów",
        items: [
          "✅ NAPRAWIONO: /api/glass/types zwracało 404",
          "✅ NAPRAWIONO: /api/settings/backups/list zwracało 404",
          "Dodano prefix='/glass' do glass router",
          "Dodano prefix='/settings' do settings router",
          "Zaktualizowano ścieżki w frontend (apiService.js, App.js)"
        ]
      },
      {
        category: "🎨 UI - Minimalistyczny Header",
        items: [
          "Przeprojektowano górny pasek na czysty, minimalistyczny design",
          "Data i czas w jednej linii (format: '07 kwi 2026 • 09:30')",
          "Transparentne tło z blur effect (backdrop-filter)",
          "Większe odstępy między elementami (gap: 48px)",
          "Płaskie przyciski bez gradientów i cieni",
          "Subtelne hover states bez animacji 3D",
          "Usunięto nadmiarowe emoji (📅, 🕐, 🆕)",
          "Mniejsza wysokość headera (72px → było 80px)"
        ]
      },
      {
        category: "📚 Dokumentacja (Gotowa do Implementacji)",
        items: [
          "📧 Email Notifications Guide - `/docs/EMAIL_NOTIFICATIONS_GUIDE.md`",
          "Zawiera: setup dla Resend/SendGrid/AWS SES, konfigurację, przykłady",
          "🔐 2FA Guide - `/docs/TWO_FACTOR_AUTH_GUIDE.md`",
          "Zawiera: TOTP setup, QR codes, backup codes, integrację z loginem",
          "Gotowe do uruchomienia gdy user dostarczy klucze API"
        ]
      },
      {
        category: "🧪 Testowanie",
        items: [
          "Testing agent: 95% sukcesu (21/22 testy backendu)",
          "Testing agent: 100% sukcesu (frontend)",
          "Przetestowano: silne hasła, rate limiting, endpoints, zmiana hasła",
          "Zweryfikowano: accessibility features w DOM/CSS"
        ]
      },
      {
        category: "📦 Nowe Biblioteki",
        items: [
          "slowapi 0.1.9 - rate limiting dla FastAPI",
          "limits 5.8.0 - dependency dla slowapi"
        ]
      }
    ],
    breaking: [
      "⚠️ ZMIANA DLA MANAGERÓW: Zatwierdzanie pracownika wymaga silnego hasła",
      "- Manager musi ustawić hasło min. 8 znaków z wielką/małą literą i cyfrą",
      "- Pracownik NIE ustawia hasła sam - dostaje je od managera",
      "- Manager nadaje uprawnienia podczas zatwierdzania",
      "",
      "⚠️ Stare hasła (< 8 znaków) będą odrzucane przy próbie zmiany",
      "⚠️ Wszyscy nowi pracownicy muszą mieć silne hasła od początku"
    ],
    fixes: [
      "Naprawiono błąd zmiany hasła w Manager tab (AllEmployeesSection.jsx)",
      "Naprawiono 404 na endpointach glass types i backups",
      "Naprawiono ścieżki API w frontend (audit-log, last-backup)"
    ]
  },
  {
    version: "v1.11.0",
    date: "2026-03-30",
    title: "Modernizacja UX - Sidebar, Optymalizacja Performance i Security",
    features: [
      {
        category: "🎨 Nowa Nawigacja - Lewy Sidebar",
        items: [
          "Przeniesiono nawigację z górnego poziomego paska na lewy pionowy sidebar",
          "Sidebar o szerokości 260px z eleganckim designem",
          "Aktywny przycisk: złoty gradient + efekt hover (przesunięcie 4px)",
          "Responsywne menu mobilne z hamburgerem (☰)",
          "Sidebar slide-in animation na mobile",
          "Dark overlay przy otwartym menu mobilnym",
          "Header i content automatycznie dopasowane (margin-left: 260px)",
          "Smooth transitions (0.3s) przy wszystkich interakcjach"
        ]
      },
      {
        category: "🔔 System Powiadomień Toast",
        items: [
          "Zastąpiono natywne alert() nowoczesnym systemem toast (Sonner)",
          "Powiadomienia: success, error, warning, info, loading",
          "Pozycja: prawy górny róg z animacjami",
          "Rich colors i close button",
          "Custom wrapper `/utils/toast.js` dla łatwego użycia",
          "Zaimplementowano w AIMenuSection i BeerCleaningTab"
        ]
      },
      {
        category: "🛡️ Error Boundaries",
        items: [
          "Wszystkie 17 zakładek owinięte w Error Boundaries",
          "Zapobiega 'białym ekranom śmierci' przy błędach JavaScript",
          "Przyjazny ekran błędu z opcją retry/refresh",
          "Piękny gradient design (fioletowy)",
          "Szczegóły błędu w trybie deweloperskim",
          "Personalizowane komunikaty dla każdego modułu po polsku"
        ]
      },
      {
        category: "🔒 Sanityzacja Inputów (XSS Protection)",
        items: [
          "Integracja DOMPurify dla ochrony przed atakami XSS",
          "Custom hook: `useSanitizedInput()` dla komponentów React",
          "Funkcja utility: `sanitizeInput()` dla kontekstów nie-hook",
          "Konfigurowalny poziom sanityzacji (z HTML lub bez)",
          "Zabezpieczono formularze w AIMenuSection (menu, instrukcje, kategorie)",
          "Zabezpieczono formularze w BeerCleaningTab (notatki)"
        ]
      },
      {
        category: "⚡ Lazy Loading & Code Splitting",
        items: [
          "Wszystkie 17 zakładek używają React.lazy()",
          "Suspense z LoadingSpinner fallback ('Ładowanie modułu...')",
          "Redukcja initial bundle size o ~52% (z 2.5MB → 1.2MB)",
          "Komponenty ładują się on-demand (tylko gdy użytkownik przełącza zakładkę)",
          "Znacznie szybsze pierwsze ładowanie aplikacji",
          "Tab switching ~540ms (bardzo szybkie)"
        ]
      },
      {
        category: "💾 API Caching (React Query)",
        items: [
          "Zainstalowano @tanstack/react-query v5.95.2",
          "QueryClientProvider opakowuje całą aplikację",
          "Konfiguracja: staleTime 5min, cacheTime 10min, retry 1",
          "Infrastruktura gotowa do migracji API calls",
          "Potencjalna redukcja redundantnych zapytań o ~80%",
          "Błyskawiczne przełączanie między zakładkami (dane z cache)"
        ]
      }
    ],
    improvements: [
      "Lewy sidebar bardziej nowoczesny i ergonomiczny niż top navbar",
      "Toast notifications znacznie lepsze UX niż natywne alerty",
      "Error Boundaries zwiększają stabilność aplikacji",
      "Performance: aplikacja ładuje się 2x szybciej dzięki lazy loading",
      "Wszystkie animacje płynne (CSS transitions)",
      "Mobile-first design z responsywnością",
      "Security: ochrona przed XSS w kluczowych formularzach"
    ],
    bugfixes: [
      "🐛 Naprawiono odświeżanie strony przy dodawaniu daty urodzin pracownika",
      "Formularz pracowników teraz używa <form> z preventDefault()",
      "Możliwość dodania pracownika przez Enter (naturalny UX)",
      "Sidebar mobile overlay z-index poprawiony",
      "Sidebar domyślnie zamknięty na mobile (useState(false))"
    ]
  },
  {
    version: "v1.10.0",
    date: "2026-03-29",
    title: "Mega aktualizacja - Tiptap, Urodziny, Wydarzenia, Promocje",
    features: [
      {
        category: "✅ Naprawione Uprawnienia",
        items: [
          "Dodano brakujące uprawnienie 'training' dla zakładki Materiały",
          "Uprawnienia teraz działają poprawnie - zakładki pokazują się po nadaniu dostępu",
          "Naprawiono system uprawnień dla Materiałów i Zakupów"
        ]
      },
      {
        category: "🎨 Nowy Edytor Tekstu - Tiptap",
        items: [
          "Zastąpiono stary edytor nowoczesnym Tiptap v3.21.0",
          "🎨 Kolory tekstu - pełna paleta kolorów",
          "🖍️ Podkreślenie kolorowe (highlighter)",
          "Formatowanie: Bold, Italic, Underline, Strikethrough",
          "Nagłówki: H1, H2, H3",
          "Listy: punktowane i numerowane",
          "Wyrównanie: lewo, środek, prawo",
          "🔗 Linki, 🖼️ Obrazki, 📊 Tabele",
          "💬 Cytaty, <> Kod, ━ Linia pozioma",
          "Dark theme stylizacja"
        ]
      },
      {
        category: "🎂 Dashboard Urodzin Pracowników",
        items: [
          "Pole 'Data urodzin' przy dodawaniu/edycji pracownika",
          "Automatyczne obliczanie wieku",
          "🎉 'Dzisiaj urodziny!' - złoty alert banner",
          "⏰ 'Zbliżające się (7 dni)' - fioletowa sekcja",
          "📅 'Wczoraj było' - różowa sekcja",
          "Badge wieku przy każdym pracowniku (🎂 25 lat)",
          "Edycja daty urodzin inline"
        ]
      },
      {
        category: "📅 Kalendarz Wydarzeń Kulinarnych",
        items: [
          "47 wydarzeń przez cały rok",
          "Automatyczne wyświetlanie w nagłówku przy dacie",
          "🎉 Dzisiaj: Złoty badge z animacją pulse",
          "📆 Wkrótce (1-7 dni): Fioletowy badge z odliczaniem",
          "Wydarzenia: Dzień pizzy, steki, burgera, Mikołajki, Sylwester i więcej",
          "Automatyczne znikanie dzień po wydarzeniu"
        ]
      },
      {
        category: "🎁 Promocje i Oferty Specjalne",
        items: [
          "Nowa zakładka 'Promocje' dla całego zespołu",
          "Dodawanie promocji z tytułem, opisem i instrukcjami",
          "Kategorie: Dania główne, Napoje, Przystawki, Deserti, Alkohole",
          "Daty obowiązywania (od-do)",
          "Automatyczne sortowanie: Aktywne / Nadchodzące / Wygasłe",
          "Edycja, włączanie/wyłączanie, usuwanie",
          "Informacje jak udzielić rabatu dla kelnerów"
        ]
      },
      {
        category: "🎨 Poprawki Wizualne",
        items: [
          "Przyciski 'Edytuj' i 'Dezaktywuj' w Pracownikach - większe i widoczne",
          "Badge wieku z ciemnym fioletowym tłem (#667eea)",
          "Dashboard urodzin - ciemniejsze gradienty (lepszy kontrast)",
          "Usunięto duplikat nagłówka 'Pracownicy'",
          "Wszystkie elementy responsywne i czytelne"
        ]
      },
      {
        category: "💾 System Backup/Restore",
        items: [
          "Backup teraz obejmuje WSZYSTKIE 20 kolekcji",
          "Dodano: promotions, deliveries, training data",
          "Weryfikacja kompletności - 100% danych zabezpieczonych",
          "Restore działa dla wszystkich nowych funkcji",
          "Żadne dane nie zostaną utracone"
        ]
      }
    ],
    improvements: [
      "Tiptap editor znacznie lepszy niż poprzedni react-quill",
      "Dashboard urodzin automatycznie aktualizuje się codziennie",
      "Wydarzenia kulinarne pomagają planować specjalne menu",
      "Promocje centralizują informacje dla zespołu",
      "Wszystkie nowe funkcje w backup/restore"
    ],
    bugfixes: [
      "Naprawiono brakujące uprawnienie 'training'",
      "Naprawiono widoczność przycisków w Pracownikach",
      "Naprawiono kolory badge wieku (teraz widoczne)",
      "Naprawiono backend import w promotions.py",
      "Naprawiono API paths w PromotionsTab.jsx"
    ]
  },
  {
    version: "v1.9.0",
    date: "2026-03-29",
    title: "Duża aktualizacja - Materiały, Zakupy, Logi i więcej",
    features: [
      {
        category: "📖 Materiały Szkoleniowe",
        items: [
          "Rich text editor z pełnym formatowaniem (nagłówki, kolory, listy, obrazy)",
          "Multi-image gallery z funkcją Lightbox (powiększanie zdjęć)",
          "YouTube video embedding",
          "Dark mode design (czarne tło, fioletowe akcenty)",
          "System uprawnień: przeglądanie, tworzenie, edycja, usuwanie",
          "Kategorie materiałów",
          "Widok przeglądania dla kelnerów",
          "Widok zarządzania dla managerów/trenerów"
        ]
      },
      {
        category: "📦 Zakupy (Dostawy) - Kraków",
        items: [
          "Nowa zakładka tylko dla Krakowa",
          "Rejestracja dostaw od kontrahentów",
          "Data i godzina dostawy",
          "Lista pozycji z ilościami (np. 4 × KEG lager 20l)",
          "Filtrowanie po kontrahencie",
          "Edycja i usuwanie dostaw",
          "Dark mode design (czarne tło, zielone akcenty)"
        ]
      },
      {
        category: "📋 Logi Systemowe",
        items: [
          "Śledzenie błędów logowania (IP, user agent, timestamp)",
          "Historia udanych i nieudanych logowań",
          "Powód błędu (użytkownik nie istnieje / złe hasło / błąd serwera)",
          "Filtrowanie po typie zdarzenia i okresie czasu",
          "Rozwijana sekcja w Ustawieniach (nie zajmuje miejsca)",
          "Automatyczne czyszczenie starych logów"
        ]
      },
      {
        category: "💾 Wskaźnik Bazy Danych",
        items: [
          "Status połączenia z bazą na ekranie logowania",
          "Auto-sprawdzanie co 10 sekund",
          "Przycisk 'Odśwież' do manualnego testu",
          "Zielony (OK) / Czerwony (błąd) wskaźnik",
          "Pomaga diagnozować problemy z logowaniem w produkcji"
        ]
      },
      {
        category: "🔪 Straty Kuchenne - Szef Kamil",
        items: [
          "Nowa elegancka kolorystyka: brązowo-miedziana paleta",
          "Personalizacja: 'Szef kuchni Kamil'",
          "Profesjonalne teksty motywacyjne",
          "Usunięto ozdobniki (serduszka, kwiatki)"
        ]
      },
      {
        category: "⚙️ Ustawienia - UX",
        items: [
          "Sekcja Użytkowników jako rozwijana zakładka",
          "Sekcja Logów Systemowych jako rozwijana zakładka",
          "Oszczędność miejsca i zasobów",
          "Czytelniejszy interfejs"
        ]
      }
    ],
    improvements: [
      "Czarne tło w zakładkach Materiały i Zakupy (zamiast fioletowego gradientu)",
      "Wszystkie funkcje działają tylko dla odpowiedniej lokalizacji",
      "Backup/restore obejmuje nowe kolekcje (deliveries, system_logs)"
    ]
  },
  {
    version: "v1.8.1",
    date: "2026-03-16",
    title: "Szkolenia AI - Quizy i Materiały",
    features: [
      {
        category: "🎓 AI Training & Quiz",
        items: [
          "Generowanie quizów przez AI (GPT-4o-mini)",
          "Quiz z karty menu dla kelnerów",
          "System punktacji i wyników",
          "Historia prób dla każdego użytkownika",
          "Weryfikacja odpowiedzi przez managera"
        ]
      }
    ]
  },
  {
    version: "v1.8.0",
    date: "2026-03-10",
    title: "Czyszczenie piwa i system uprawnień",
    features: [
      {
        category: "🍺 Beer Cleaning",
        items: [
          "Harmonogram czyszczenia linii piwnych",
          "Automatyczne przypomnienia",
          "Historia czyszczeń"
        ]
      },
      {
        category: "👥 System Uprawnień",
        items: [
          "Granularne uprawnienia dla użytkowników",
          "Edytor uprawnień w Ustawieniach",
          "Kontrola dostępu do różnych zakładek"
        ]
      }
    ]
  },
  {
    version: "v1.7.0",
    date: "2026-02-28",
    title: "Straty kuchenne i szkła",
    features: [
      {
        category: "🔪 Kitchen Losses",
        items: [
          "Rejestracja strat kuchennych",
          "Wyszukiwanie produktów",
          "Kategorie strat",
          "Raporty strat"
        ]
      },
      {
        category: "🍷 Glass Tracking",
        items: [
          "Śledzenie szkła",
          "Typy szkła",
          "Historia strat szkła"
        ]
      }
    ]
  },
  {
    version: "v1.6.0",
    date: "2026-02-15",
    title: "Odzież pracownicza",
    features: [
      {
        category: "👕 Clothing Management",
        items: [
          "Ewidencja odzieży dla pracowników",
          "Typy odzieży",
          "Przypisywanie do użytkowników",
          "Status odzieży (aktywna/usunięta)"
        ]
      }
    ]
  },
  {
    version: "v1.5.0",
    date: "2026-02-01",
    title: "Billard i rozszerzenia",
    features: [
      {
        category: "🎱 Billard",
        items: [
          "Śledzenie gier bilardowych",
          "Ceny za godzinę/czas",
          "Historia gier"
        ]
      }
    ]
  },
  {
    version: "v1.0.0",
    date: "2026-01-15",
    title: "Wydanie podstawowe - System napiwków",
    features: [
      {
        category: "💰 Napiwki",
        items: [
          "Dodawanie napiwków dla kelnerów",
          "Podsumowanie dzienne",
          "Podsumowanie miesięczne",
          "Podział napiwków",
          "Eksport do PDF"
        ]
      },
      {
        category: "👥 Zarządzanie Pracownikami",
        items: [
          "Lista kelnerów",
          "Statusy pracowników",
          "Zarządzanie użytkownikami"
        ]
      },
      {
        category: "📊 Raporty",
        items: [
          "Raporty dzienne",
          "Raporty miesięczne",
          "Statystyki"
        ]
      },
      {
        category: "⚙️ Ustawienia",
        items: [
          "Backup/Restore bazy danych",
          "Zarządzanie użytkownikami",
          "Stanowiska pracy",
          "Multi-lokalizacja (Kraków, Nowy Sącz)"
        ]
      }
    ]
  }
];

export default APP_CHANGELOG;
